export const Aliases: import('../sim/dex').AliasesTable = {
	// formats
	randbats: "[Gen 9] Random Battle",
	randbat: "[Gen 9] Random Battle",
	uber: "[Gen 9] Ubers",
	anythinggoes: "[Gen 9] Anything Goes",
	ubers: "[Gen 9] Ubers",
	uubers: "[Gen 9] Ubers UU",
	overused: "[Gen 9] OU",
	underused: "[Gen 9] UU",
	rarelyused: "[Gen 9] RU",
	neverused: "[Gen 9] NU",
	pu: "[Gen 9] PU",
	zu: "[Gen 9] ZU",
	zeroused: "[Gen 9] ZU",
	mono: "[Gen 9] Monotype",
	ag: "[Gen 9] Anything Goes",
	champsou: "[Gen 9 Champions] OU",
	cou: "[Gen 9 Champions] OU",
	champsuu: "[Gen 9 Champions] UU",
	cuu: "[Gen 9 Champions] UU",
	bss: "[Gen 9 Champions] BSS Reg M-A",
	vgc: "[Gen 9 Champions] VGC 2026 Reg M-A",
	bsd: "[Gen 9 Champions] VGC 2026 Reg M-A",
	randdubs: "[Gen 9] Random Doubles Battle",
	doubles: "[Gen 9] Doubles OU",
	dou: "[Gen 9] Doubles OU",
	dubs: "[Gen 9] Doubles OU",
	dubers: "[Gen 9] Doubles Ubers",
	duu: "[Gen 9] Doubles UU",
	"2v2": "[Gen 9] 2v2 Doubles",
	natdex: "[Gen 9] National Dex",
	nd: "[Gen 9] National Dex",
	ndou: "[Gen 9] National Dex",
	gen8natdex: "[Gen 8] National Dex",
	gen8nd: "[Gen 8] National Dex",
	gen8ndou: "[Gen 8] National Dex",
	natdexubers: "[Gen 9] National Dex Ubers",
	ndubers: "[Gen 9] National Dex Ubers",
	natdexuu: "[Gen 9] National Dex UU",
	nduu: "[Gen 9] National Dex UU",
	natdexru: "[Gen 9] National Dex RU",
	ndru: "[Gen 9] National Dex RU",
	natdexmonotype: "[Gen 9] National Dex Monotype",
	natdexmono: "[Gen 9] National Dex Monotype",
	ndmono: "[Gen 9] National Dex Monotype",
	nd1v1: "[Gen 9] National Dex 1v1",
	natdex1v1: "[Gen 9] National Dex 1v1",
	natdexag: "[Gen 9] National Dex AG",
	ndag: "[Gen 9] National Dex AG",
	natdexbh: "[Gen 9] National Dex BH",
	ndbh: "[Gen 9] National Dex BH",
	bh: "[Gen 9] Balanced Hackmons",
	mnm: "[Gen 9] Mix and Mega",
	aaa: "[Gen 9] Almost Any Ability",
	stab: "[Gen 9] STABmons",
	gg: "[Gen 9] Godly Gift",
	pic: "[Gen 9] Partners in Crime",
	camo: "[Gen 9] Camomons",
	revmons: "[Gen 9] Revelationmons",
	tcg: "[Gen 9] The Card Game",
	ffa: "[Gen 9] Free-For-All",
	ph: "[Gen 9] Pure Hackmons",
	hackmons: "[Gen 9] Pure Hackmons",
	gen6ph: "[Gen 6] Pure Hackmons",
	gen6hackmons: "[Gen 6] Pure Hackmons",
	cc1v1: "[Gen 9] Challenge Cup 1v1",
	cc2v2: "[Gen 9] Challenge Cup 2v2",
	hc: "[Gen 9] Hackmons Cup",
	bf: "[Gen 8] Battle Factory",
	bssf: "[Gen 9] BSS Factory",
	ssb: "[Gen 9] Super Staff Bros Ultimate",
	ssbu: "[Gen 9] Super Staff Bros Ultimate",
	lgrandom: "[Gen 7 Let's Go] Random Battle",
	gen6bf: "[Gen 6] Battle Factory",
	gen7mono: "[Gen 7] Monotype",
	gen7ag: "[Gen 7] Anything Goes",
	gen7bf: "[Gen 7] Battle Factory",
	gen7bss: "[Gen 7] Battle Spot Singles",
	gen7bssf: "[Gen 7] BSS Factory",
	gen8bssf: "[Gen 8] BSS Factory",
	lgpeou: "[Gen 7 Let's Go] OU",
	lgou: "[Gen 7 Let's Go] OU",
	lgdou: "[Gen 7 Let's Go] Doubles OU",
	lgpedou: "[Gen 7 Let's Go] OU",
	vgc20: "[Gen 8] VGC 2020",
	vgc19: "[Gen 7] VGC 2019",
	vgc18: "[Gen 7] VGC 2018",
	vgc17: "[Gen 7] VGC 2017",
	gen7bsd: "[Gen 7] Battle Spot Doubles",
	gen6mono: "[Gen 6] Monotype",
	gen6ag: "[Gen 6] Anything Goes",
	crossevo: "[Gen 9] Cross Evolution",
	mayhem: "[Gen 9] Random Battle Mayhem",
	omotm: "[Gen 9] Sketchmons",
	lcotm: "[Gen 9] Partners in Crime",
	ommotm: "[Gen 9] Pokebilities BH",
	ommspotlight: "[Gen 9] Pokebilities BH",
	pmotm: "[Gen 9] woomod Random Battle",
	ccapm: "[Gen 9] CCAPM2025 Random Battle",

	// mega evos --- 1st ordered alphabetically by species, 2nd by alias
	megasnow: "Abomasnow-Mega",
	maero: "Aerodactyl-Mega",
	malt: "Altaria-Mega",
	maud: "Audino-Mega",
	fabio: "Ampharos-Mega",
	megadrill: "Beedrill-Mega",
	megacharizardx: "Charizard-Mega-X",
	xard: "Charizard-Mega-X",
	zardx: "Charizard-Mega-X",
	megacharizard: "Charizard-Mega-Y",
	megacharizardy: "Charizard-Mega-Y",
	yard: "Charizard-Mega-Y",
	zardy: "Charizard-Mega-Y",
	megacruci: "Crucibelle-Mega",
	mdia: "Diancie-Mega",
	floetteeternalmega: "Floette-Mega",
	megafloetteeternal: "Floette-Mega",
	megagard: "Gardevoir-Mega",
	megacross: "Heracross-Mega",
	megadoom: "Houndoom-Mega",
	megakhan: "Kangaskhan-Mega",
	mlop: "Lopunny-Mega",
	megalop: "Lopunny-Mega",
	megabunny: "Lopunny-Mega",
	mluc: "Lucario-Mega",
	megaluc: "Lucario-Mega",
	mmanec: "Manectric-Mega",
	mmane: "Manectric-Mega",
	mmaw: "Mawile-Mega",
	megamaw: "Mawile-Mega",
	mmedi: "Medicham-Mega",
	megamedi: "Medicham-Mega",
	meowsticmega: "Meowstic-M-Mega",
	mmx: "Mewtwo-Mega-X",
	megamewtwox: "Mewtwo-Mega-X",
	mewtwox: "Mewtwo-Mega-X",
	mmy: "Mewtwo-Mega-Y",
	megamewtwo: "Mewtwo-Mega-Y",
	megamewtwoy: "Mewtwo-Mega-Y",
	mewtwoy: "Mewtwo-Mega-Y",
	megashark: "Sharpedo-Mega",
	mbro: "Slowbro-Mega",
	megabro: "Slowbro-Mega",
	tatsugirimega: "Tatsugiri-Curly-Mega",
	megasaur: "Venusaur-Mega",
	megazygardecomplete: "Zygarde-Mega",
	zygardecompletemega: "Zygarde-Mega",

	// Pokéstar Studios --- 1st ordered alphabetically by species, 2nd by alias
	blackdoor: "Pokestar Black Door",
	brycen: "Pokestar Brycen-Man",
	brycenman: "Pokestar Brycen-Man",
	f00: "Pokestar F-00",
	f002: "Pokestar F-002",
	giant: "Pokestar Giant",
	mt: "Pokestar MT",
	mt2: "Pokestar MT2",
	majin: "Pokestar Spirit",
	mechatyranitar: "Pokestar MT",
	mechatyranitar2: "Pokestar MT2",
	monica: "Pokestar Giant",
	spirit: "Pokestar Spirit",
	transport: "Pokestar Transport",
	pokestarufof: "Pokestar UFO",
	pokestarufoflying: "Pokestar UFO",
	ufo: "Pokestar UFO",
	ufof: "Pokestar UFO",
	ufoflying: "Pokestar UFO",
	ufo2: "Pokestar UFO-2",
	ufop: "Pokestar UFO-2",
	ufopsychic: "Pokestar UFO-2",
	whitedoor: "Pokestar White Door",

	// Cosmetic Pokestar Studios formes --- unordered
	pokestargiant2: "Pokestar Giant",
	pokestarmonica2: "Pokestar Giant",
	pokestarufopropu1: "Pokestar UFO",
	pokestarpropu1: "Pokestar UFO",
	pokestarpropu2: "Pokestar UFO-2",
	pokestarbrycenmanprop: "Pokestar Brycen-Man",
	pokestarproph1: "Pokestar Brycen-Man",
	pokestarmtprop: "Pokestar MT",
	pokestarpropm1: "Pokestar MT",
	pokestarmt2prop: "Pokestar MT2",
	pokestarpropm2: "Pokestar MT2",
	pokestartransportprop: "Pokestar Transport",
	pokestarpropt1: "Pokestar Transport",
	pokestargiantpropo1: "Pokestar Giant",
	pokestarpropo1: "Pokestar Giant",
	pokestargiantpropo2: "Pokestar Giant",
	pokestarpropo2: "Pokestar Giant",
	pokestarhumanoidprop: "Pokestar Humanoid",
	pokestarpropc1: "Pokestar Humanoid",
	pokestarmonsterprop: "Pokestar Monster",
	pokestarpropc2: "Pokestar Monster",
	pokestarspiritprop: "Pokestar Spirit",
	pokestarpropg1: "Pokestar Spirit",
	pokestarblackdoorprop: "Pokestar Black Door",
	pokestarpropw1: "Pokestar Black Door",
	pokestarwhitedoorprop: "Pokestar White Door",
	pokestarpropw2: "Pokestar White Door",
	pokestarf00prop: "Pokestar F-00",
	pokestarpropr1: "Pokestar F-00",
	pokestarf002prop: "Pokestar F-002",
	pokestarpropr2: "Pokestar F-002",
	pokestarblackbeltprop: "Pokestar Black Belt",
	pokestarpropk1: "Pokestar Black Belt",
	giant2: "Pokestar Giant",
	monica2: "Pokestar Giant",
	ufopropu1: "Pokestar UFO",
	propu1: "Pokestar UFO",
	ufopropu2: "Pokestar UFO-2",
	propu2: "Pokestar UFO-2",
	brycenmanprop: "Pokestar Brycen-Man",
	proph1: "Pokestar Brycen-Man",
	mtprop: "Pokestar MT",
	propm1: "Pokestar MT",
	mt2prop: "Pokestar MT2",
	propm2: "Pokestar MT2",
	transportprop: "Pokestar Transport",
	propt1: "Pokestar Transport",
	giantpropo1: "Pokestar Giant",
	propo1: "Pokestar Giant",
	giantpropo2: "Pokestar Giant",
	propo2: "Pokestar Giant",
	humanoidprop: "Pokestar Humanoid",
	propc1: "Pokestar Humanoid",
	monsterprop: "Pokestar Monster",
	propc2: "Pokestar Monster",
	spiritprop: "Pokestar Spirit",
	propg1: "Pokestar Spirit",
	blackdoorprop: "Pokestar Black Door",
	propw1: "Pokestar Black Door",
	whitedoorprop: "Pokestar White Door",
	propw2: "Pokestar White Door",
	f00prop: "Pokestar F-00",
	propr1: "Pokestar F-00",
	f002prop: "Pokestar F-002",
	propr2: "Pokestar F-002",
	blackbeltprop: "Pokestar Black Belt",
	propk1: "Pokestar Black Belt",

	// formes --- 1st ordered alphabetically by species, 2nd by alias
	harc: "Arcanine-Hisui",
	arcbug: "Arceus-Bug",
	bugceus: "Arceus-Bug",
	arcdark: "Arceus-Dark",
	darkceus: "Arceus-Dark",
	arcdragon: "Arceus-Dragon",
	dragonceus: "Arceus-Dragon",
	eleceus: "Arceus-Electric",
	arcelectric: "Arceus-Electric",
	arcfairy: "Arceus-Fairy",
	fairyceus: "Arceus-Fairy",
	arcfighting: "Arceus-Fighting",
	fightceus: "Arceus-Fighting",
	arcfire: "Arceus-Fire",
	fireceus: "Arceus-Fire",
	arcflying: "Arceus-Flying",
	flyceus: "Arceus-Flying",
	ghostceus: "Arceus-Ghost",
	arcghost: "Arceus-Ghost",
	grassceus: "Arceus-Grass",
	arcgrass: "Arceus-Grass",
	arcground: "Arceus-Ground",
	groundceus: "Arceus-Ground",
	arcice: "Arceus-Ice",
	iceceus: "Arceus-Ice",
	arcpoison: "Arceus-Poison",
	poisonceus: "Arceus-Poison",
	arcpsychic: "Arceus-Psychic",
	psyceus: "Arceus-Psychic",
	arcrock: "Arceus-Rock",
	rockceus: "Arceus-Rock",
	arcsteel: "Arceus-Steel",
	steelceus: "Arceus-Steel",
	arcwater: "Arceus-Water",
	waterceus: "Arceus-Water",
	basculegionm: "Basculegion",
	basculinb: "Basculin-Blue-Striped",
	basculinblue: "Basculin-Blue-Striped",
	basculinbluestripe: "Basculin-Blue-Striped",
	basculinw: "Basculin-White-Striped",
	basculinwhite: "Basculin-White-Striped",
	basculinwhitestripe: "Basculin-White-Striped",
	calyi: "Calyrex-Ice",
	calyice: "Calyrex-Ice",
	calyrexicerider: "Calyrex-Ice",
	calyrexir: "Calyrex-Ice",
	calys: "Calyrex-Shadow",
	calyshadow: "Calyrex-Shadow",
	calyrexshadowrider: "Calyrex-Shadow",
	calyrexsr: "Calyrex-Shadow",
	cir: "Calyrex-Ice",
	csr: "Calyrex-Shadow",
	castformh: "Castform-Snowy",
	castformice: "Castform-Snowy",
	castformr: "Castform-Rainy",
	castformwater: "Castform-Rainy",
	castforms: "Castform-Sunny",
	castformfire: "Castform-Sunny",
	cherrims: "Cherrim-Sunshine",
	cherrimsunny: "Cherrim-Sunshine",
	darmgz: "Darmanitan-Galar-Zen",
	darmanitanzengalar: "Darmanitan-Galar-Zen",
	darmanitanz: "Darmanitan-Zen",
	darmanitanzenmode: "Darmanitan-Zen",
	darmz: "Darmanitan-Zen",
	decidh: "Decidueye-Hisui",
	deon: "Deoxys",
	deoxysnormal: "Deoxys",
	deoa: "Deoxys-Attack",
	deoxysa: "Deoxys-Attack",
	deod: "Deoxys-Defense",
	deoxysd: "Deoxys-Defense",
	deoxysdefence: "Deoxys-Defense",
	deos: "Deoxys-Speed",
	deoxyss: "Deoxys-Speed",
	dialgao: "Dialga-Origin",
	eiscueice: "Eiscue",
	eiscuen: "Eiscue-Noice",
	trodeh: "Electrode-Hisui",
	enamorust: "Enamorus-Therian",
	enamt: "Enamorus-Therian",
	eternamax: "Eternatus-Eternamax",
	eternalfloette: "Floette-Eternal",
	floettee: "Floette-Eternal",
	floetteeternalflower: "Floette-Eternal",
	genesectwater: "Genesect-Douse",
	genesectelectric: "Genesect-Shock",
	genesectfire: "Genesect-Burn",
	genesectice: "Genesect-Chill",
	girao: "Giratina-Origin",
	giratinao: "Giratina-Origin",
	alolem: "Golem-Alola",
	hoodra: "Goodra-Hisui",
	gourgeists: "Gourgeist-Small",
	gourgeistl: "Gourgeist-Large",
	gourgeistxl: "Gourgeist-Super",
	gourgeisth: "Gourgeist-Super",
	gourgeisthuge: "Gourgeist-Super",
	gourgeistjumbo: "Gourgeist-Super",
	ashgreninja: "Greninja-Ash",
	greninjabattlebond: "Greninja-Bond",
	pdon: "Groudon-Primal",
	growlh: "Growlithe-Hisui",
	hoopau: "Hoopa-Unbound",
	nddf: "Indeedee-F",
	keldeor: "Keldeo-Resolute",
	keldeoresolution: "Keldeo-Resolute",
	kyuremb: "Kyurem-Black",
	kyuremw: "Kyurem-White",
	landorust: "Landorus-Therian",
	landot: "Landorus-Therian",
	hlil: "Lilligant-Hisui",
	hisuigant: "Lilligant-Hisui",
	lycanrocmidday: "Lycanroc",
	lycanrocday: "Lycanroc",
	lycanm: "Lycanroc-Midnight",
	lycanrocn: "Lycanroc-Midnight",
	lycanrocnight: "Lycanroc-Midnight",
	duskroc: "Lycanroc-Dusk",
	lycand: "Lycanroc-Dusk",
	lycanrocd: "Lycanroc-Dusk",
	alowak: "Marowak-Alola",
	meloettap: "Meloetta-Pirouette",
	meloettas: "Meloetta-Pirouette",
	meloettastep: "Meloetta-Pirouette",
	meowsticfemale: "Meowstic-F",
	goltres: "Moltres-Galar",
	gmolt: "Moltres-Galar",
	morpekofullbelly: "Morpeko",
	morpekoh: "Morpeko-Hangry",
	rime: "Mr. Rime",
	alomuk: "Muk-Alola",
	ndm: "Necrozma-Dusk-Mane",
	ndw: "Necrozma-Dawn-Wings",
	necrozmadm: "Necrozma-Dusk-Mane",
	necrozmadusk: "Necrozma-Dusk-Mane",
	duskmane: "Necrozma-Dusk-Mane",
	duskmanenecrozma: "Necrozma-Dusk-Mane",
	necrozmadw: "Necrozma-Dawn-Wings",
	necrozmadawn: "Necrozma-Dawn-Wings",
	dawnwings: "Necrozma-Dawn-Wings",
	dawnwingsnecrozma: "Necrozma-Dawn-Wings",
	necrozmau: "Necrozma-Ultra",
	ultranecro: "Necrozma-Ultra",
	ultranecrozma: "Necrozma-Ultra",
	unecro: "Necrozma-Ultra",
	alotales: "Ninetales-Alola",
	alolatales: "Ninetales-Alola",
	goon: "Obstagoon",
	woger: "Ogerpon-Wellspring",
	cornerpon: "Ogerpon-Cornerstone",
	waterpon: "Ogerpon-Wellspring",
	wetpon: "Ogerpon-Wellspring",
	rockpon: "Ogerpon-Cornerstone",
	stonepon: "Ogerpon-Cornerstone",
	firepon: "Ogerpon-Hearthflame",
	ogerw: "Ogerpon-Wellspring",
	ogerc: "Ogerpon-Cornerstone",
	ogerh: "Ogerpon-Hearthflame",
	ogerponw: "Ogerpon-Wellspring",
	ogerponc: "Ogerpon-Cornerstone",
	ogerponh: "Ogerpon-Hearthflame",
	ogerponwater: "Ogerpon-Wellspring",
	ogerponrock: "Ogerpon-Cornerstone",
	ogerponfire: "Ogerpon-Hearthflame",
	ogerponwellspringmask: "Ogerpon-Wellspring",
	ogerponcornerstonemask: "Ogerpon-Cornerstone",
	ogerponhearthflamemask: "Ogerpon-Hearthflame",
	oricoriob: "Oricorio",
	oricoriobaile: "Oricorio",
	oricoriof: "Oricorio",
	oricoriofire: "Oricorio",
	oricorioe: "Oricorio-Pom-Pom",
	oricorioelectric: "Oricorio-Pom-Pom",
	oricoriog: "Oricorio-Sensu",
	oricorioghost: "Oricorio-Sensu",
	oricorios: "Oricorio-Sensu",
	oricoriop: "Oricorio-Pa'u",
	oricoriopsychic: "Oricorio-Pa'u",
	palafinh: "Palafin-Hero",
	palkiao: "Palkia-Origin",
	horsepalkia: "Palkia-Origin",
	alosian: "Persian-Alola",
	ponyg: "Ponyta-Galar",
	pumpkaboos: "Pumpkaboo-Small",
	pumpkabool: "Pumpkaboo-Large",
	pumpkabooxl: "Pumpkaboo-Super",
	pumpkabooh: "Pumpkaboo-Super",
	pumpkaboohuge: "Pumpkaboo-Super",
	pumpkaboojumbo: "Pumpkaboo-Super",
	hqwil: "Qwilfish-Hisui",
	gorse: "Rapidash-Galar",
	galardash: "Rapidash-Galar",
	rotoms: "Rotom-Fan",
	rotomspin: "Rotom-Fan",
	rotomf: "Rotom-Frost",
	fridge: "Rotom-Frost",
	rotomh: "Rotom-Heat",
	rotomc: "Rotom-Mow",
	rotomcut: "Rotom-Mow",
	rotomw: "Rotom-Wash",
	wash: "Rotom-Wash",
	ham: "Samurott-Hisui",
	hamurott: "Samurott-Hisui",
	snowslash: "Sandslash-Alola",
	shaymins: "Shaymin-Sky",
	skymin: "Shaymin-Sky",
	glowbro: "Slowbro-Galar",
	gbro: "Slowbro-Galar",
	glowking: "Slowking-Galar",
	gking: "Slowking-Galar",
	squawkabillyb: "Squawkabilly-Blue",
	squawkabillyw: "Squawkabilly-White",
	squawkabillyy: "Squawkabilly-Yellow",
	taurospaldea: "Tauros-Paldea-Combat",
	taurospaldeafire: "Tauros-Paldea-Blaze",
	taurospaldeawater: "Tauros-Paldea-Aqua",
	redbull: "Tauros-Paldea-Blaze",
	wetbull: "Tauros-Paldea-Aqua",
	terapagoss: "Terapagos-Stellar",
	terapagost: "Terapagos-Terastal",
	pagos: "Terapagos-Terastal",
	thundurust: "Thundurus-Therian",
	thundyt: "Thundurus-Therian",
	tornadust: "Tornadus-Therian",
	tornt: "Tornadus-Therian",
	toxtricityl: "Toxtricity-Low-Key",
	toxtricitylk: "Toxtricity-Low-Key",
	typhh: "Typhlosion-Hisui",
	blursa: "Ursaluna-Bloodmoon",
	ursab: "Ursaluna-Bloodmoon",
	ursalunab: "Ursaluna-Bloodmoon",
	darkshifu: "Urshifu",
	shifu: "Urshifu",
	urshifuss: "Urshifu",
	urshifusingle: "Urshifu",
	urshifusinglestrike: "Urshifu",
	urshifusinglestrikegmax: "Urshifu-Gmax",
	urshifurs: "Urshifu-Rapid-Strike",
	urshifurapid: "Urshifu-Rapid-Strike",
	watershifu: "Urshifu-Rapid-Strike",
	torbh: "Voltorb-Hisui",
	geezing: "Weezing-Galar",
	gweez: "Weezing-Galar",
	wormadamg: "Wormadam-Sandy",
	wormadamground: "Wormadam-Sandy",
	wormadamsandycloak: "Wormadam-Sandy",
	wormadamsteel: "Wormadam-Trash",
	wormadamtrashcloak: "Wormadam-Trash",
	zacianh: "Zacian",
	zacianhero: "Zacian",
	zacianc: "Zacian-Crowned",
	zamazentah: "Zamazenta",
	zamazentahero: "Zamazenta",
	zamazentac: "Zamazenta-Crowned",
	gapdos: "Zapdos-Galar",
	hzoro: "Zoroark-Hisui",
	zydog: "Zygarde-10%",
	zydoge: "Zygarde-10%",
	zygardedog: "Zygarde-10%",
	zygarde50: "Zygarde",
	perfectzygarde: "Zygarde-Complete",
	zyc: "Zygarde-Complete",
	zygarde100: "Zygarde-Complete",
	zygardec: "Zygarde-Complete",
	zygardefull: "Zygarde-Complete",
	zygod: "Zygarde-Complete",

	// base formes --- 1st ordered alphabetically by species, 2nd by alias
	aegislashs: "Aegislash",
	aegislashshield: "Aegislash",
	basculinr: "Basculin",
	basculinred: "Basculin",
	basculinredstripe: "Basculin",
	basculinredstriped: "Basculin",
	cherrimo: "Cherrim",
	cherrimovercast: "Cherrim",
	darmanitans: "Darmanitan",
	darmanitanstandard: "Darmanitan",
	darmanitanstandardmode: "Darmanitan",
	dudunsparcetwosegment: "Dudunsparce",
	enamorusi: "Enamorus",
	enamorusincarnate: "Enamorus",
	enamorusincarnation: "Enamorus",
	furfrounatural: "Furfrou",
	gimmighoulchest: "Gimmighoul",
	giratinaa: "Giratina",
	giratinaaltered: "Giratina",
	gourgeistaverage: "Gourgeist",
	gourgeistm: "Gourgeist",
	gourgeistmedium: "Gourgeist",
	hoopac: "Hoopa",
	hoopaconfined: "Hoopa",
	indeedeem: "Indeedee",
	keldeoo: "Keldeo",
	keldeoordinary: "Keldeo",
	lando: "Landorus",
	landoi: "Landorus",
	landorusi: "Landorus",
	landorusincarnate: "Landorus",
	landorusincarnation: "Landorus",
	mausholdthree: "Maushold",
	melo: "Meloetta",
	meloettaa: "Meloetta",
	meloettaaria: "Meloetta",
	meloettavoice: "Meloetta",
	meowsticm: "Meowstic",
	meowsticmale: "Meowstic",
	mimikyudisguised: "Mimikyu",
	nidoranfemale: "Nidoran-F",
	nidoranmale: "Nidoran-M",
	tealpon: "Ogerpon",
	grasspon: "Ogerpon",
	ogerpont: "Ogerpon",
	ogerponteal: "Ogerpon",
	ogerpontealmask: "Ogerpon",
	oinkolognem: "Oinkologne",
	palafinzero: "Palafin",
	poltchageistcounterfeit: "Poltchageist",
	polteageistphony: "Polteageist",
	pumpkabooaverage: "Pumpkaboo",
	pumpkaboom: "Pumpkaboo",
	pumpkaboomedium: "Pumpkaboo",
	rockruffmidday: "Rockruff",
	shayminl: "Shaymin",
	shayminland: "Shaymin",
	sinisteaphony: "Sinistea",
	sinistchaunremarkable: "Sinistcha",
	squawkabillygreen: "Squawkabilly",
	squawkabillyg: "Squawkabilly",
	terapagosbaby: "Terapagos",
	thundurusi: "Thundurus",
	thundurusincarnate: "Thundurus",
	thundurusincarnation: "Thundurus",
	thundy: "Thundurus",
	torn: "Tornadus",
	tornadusi: "Tornadus",
	tornadusincarnate: "Tornadus",
	tornadusincarnation: "Tornadus",
	toxtricitya: "Toxtricity",
	toxtricityamped: "Toxtricity",
	toxtricityampedgmax: "Toxtricity-Gmax",
	vivillonmeadow: "Vivillon",
	wishiwashisolo: "Wishiwashi",
	wormadamgrass: "Wormadam",
	wormadamp: "Wormadam",
	wormadamplant: "Wormadam",
	wormadamplantcloak: "Wormadam",
	xerneasactive: "Xerneas",

	// totem formes --- 1st ordered alphabetically by species, 2nd by alias
	araquanidt: "Araquanid-Totem",
	totemaraquanid: "Araquanid-Totem",
	gumshoost: "Gumshoos-Totem",
	totemgumshoos: "Gumshoos-Totem",
	kommoot: "Kommo-o-Totem",
	totemkommoo: "Kommo-o-Totem",
	lurantist: "Lurantis-Totem",
	totemlurantis: "Lurantis-Totem",
	marowakt: "Marowak-Alola-Totem",
	totemalolanmarowak: "Marowak-Alola-Totem",
	totemmarowak: "Marowak-Alola-Totem",
	totemmarowaka: "Marowak-Alola-Totem",
	totemmarowakalola: "Marowak-Alola-Totem",
	mimikyut: "Mimikyu-Totem",
	totemmimikyu: "Mimikyu-Totem",
	raticatet: "Raticate-Alola-Totem",
	totemalolanraticate: "Raticate-Alola-Totem",
	totemraticate: "Raticate-Alola-Totem",
	totemraticatea: "Raticate-Alola-Totem",
	totemraticatealola: "Raticate-Alola-Totem",
	ribombeet: "Ribombee-Totem",
	totemribombee: "Ribombee-Totem",
	salazzlet: "Salazzle-Totem",
	totemsalazzle: "Salazzle-Totem",
	totemvikavolt: "Vikavolt-Totem",
	vikavoltt: "Vikavolt-Totem",

	// Past Paradox Pokemon --- 1st ordered alphabetically by species, 2nd by alias
	bonnet: "Brute Bonnet",
	flutter: "Flutter Mane",
	fmane: "Flutter Mane",
	gfire: "Gouging Fire",
	goug: "Gouging Fire",
	gouging: "Gouging Fire",
	grusk: "Great Tusk",
	gtusk: "Great Tusk",
	tusk: "Great Tusk",
	bolt: "Raging Bolt",
	greatneck: "Raging Bolt",
	neck: "Raging Bolt",
	raging: "Raging Bolt",
	rmoon: "Roaring Moon",
	moon: "Roaring Moon",
	sandy: "Sandy Shocks",
	shocks: "Sandy Shocks",
	stail: "Scream Tail",
	slither: "Slither Wing",
	swing: "Slither Wing",
	wake: "Walking Wake",
	ww: "Walking Wake",

	// Future Paradox Pokemon --- 1st ordered alphabetically by species, 2nd by alias
	boulder: "Iron Boulder",
	bundle: "Iron Bundle",
	bundlechan: "Iron Bundle",
	crown: "Iron Crown",
	icrown: "Iron Crown",
	hands: "Iron Hands",
	thorns: "Iron Thorns",
	jug: "Iron Jugulis",
	jugulis: "Iron Jugulis",
	ileaves: "Iron Leaves",
	leaves: "Iron Leaves",
	moth: "Iron Moth",
	treads: "Iron Treads",
	val: "Iron Valiant",
	ival: "Iron Valiant",
	valiant: "Iron Valiant",

	// cosmetic formes --- 1st ordered alphabetically by species, 2nd by alias
	alcremievanillacream: "Alcremie",
	alcremierubycream: "Alcremie",
	alcremiematchacream: "Alcremie",
	alcremiemintcream: "Alcremie",
	alcremielemoncream: "Alcremie",
	alcremiesaltedcream: "Alcremie",
	alcremierubyswirl: "Alcremie",
	alcremiecaramelswirl: "Alcremie",
	alcremierainbowswirl: "Alcremie",
	burmygrass: "Burmy",
	burmyplant: "Burmy",
	burmysandy: "Burmy",
	burmytrash: "Burmy",
	deerlingspring: "Deerling",
	deerlingsummer: "Deerling",
	deerlingautumn: "Deerling",
	deerlingwinter: "Deerling",
	flabb: "Flabébé",
	flabebered: "Flabébé",
	flabebeblue: "Flabébé",
	flabebeorange: "Flabébé",
	flabebewhite: "Flabébé",
	flabebeyellow: "Flabébé",
	flabbred: "Flabébé",
	flabbblue: "Flabébé",
	flabborange: "Flabébé",
	flabbwhite: "Flabébé",
	flabbyellow: "Flabébé",
	floettered: "Floette",
	floetteblue: "Floette",
	floetteorange: "Floette",
	floettewhite: "Floette",
	floetteyellow: "Floette",
	florgesred: "Florges",
	florgesblue: "Florges",
	florgesorange: "Florges",
	florgeswhite: "Florges",
	florgesyellow: "Florges",
	furfroudandy: "Furfrou",
	furfroudebutante: "Furfrou",
	furfroudiamond: "Furfrou",
	furfrouheart: "Furfrou",
	furfroukabuki: "Furfrou",
	furfroulareine: "Furfrou",
	furfroumatron: "Furfrou",
	furfroupharaoh: "Furfrou",
	furfroustar: "Furfrou",
	gastrodone: "Gastrodon",
	gastrodoneast: "Gastrodon",
	gastrodoneastsea: "Gastrodon",
	gastrodonw: "Gastrodon",
	gastrodonwest: "Gastrodon",
	gastrodonwestsea: "Gastrodon",
	miniorred: "Minior",
	miniororange: "Minior",
	minioryellow: "Minior",
	miniorgreen: "Minior",
	miniorblue: "Minior",
	miniorindigo: "Minior",
	miniorviolet: "Minior",
	shelloseast: "Shellos",
	shelloswest: "Shellos",
	sawsbuckspring: "Sawsbuck",
	sawsbucksummer: "Sawsbuck",
	sawsbuckautumn: "Sawsbuck",
	sawsbuckwinter: "Sawsbuck",
	tatsugiricurly: "Tatsugiri",
	unowna: "Unown",
	unownb: "Unown",
	unownc: "Unown",
	unownd: "Unown",
	unowne: "Unown",
	unownf: "Unown",
	unowng: "Unown",
	unownh: "Unown",
	unowni: "Unown",
	unownj: "Unown",
	unownk: "Unown",
	unownl: "Unown",
	unownm: "Unown",
	unownn: "Unown",
	unowno: "Unown",
	unownp: "Unown",
	unownq: "Unown",
	unownr: "Unown",
	unowns: "Unown",
	unownt: "Unown",
	unownu: "Unown",
	unownv: "Unown",
	unownw: "Unown",
	unownx: "Unown",
	unowny: "Unown",
	unownz: "Unown",
	unownexclamation: "Unown",
	unownquestion: "Unown",
	vivillonarchipelago: "Vivillon",
	vivilloncontinental: "Vivillon",
	vivillonelegant: "Vivillon",
	vivillongarden: "Vivillon",
	vivillonhighplains: "Vivillon",
	vivillonicysnow: "Vivillon",
	vivillonjungle: "Vivillon",
	vivillonmarine: "Vivillon",
	vivillonmodern: "Vivillon",
	vivillonmonsoon: "Vivillon",
	vivillonocean: "Vivillon",
	vivillonpolar: "Vivillon",
	vivillonriver: "Vivillon",
	vivillonsandstorm: "Vivillon",
	vivillonsavanna: "Vivillon",
	vivillonsun: "Vivillon",
	vivillontundra: "Vivillon",

	// abilities --- 1st ordered alphabetically by ability name, 2nd by alias
	adapt: "Adaptability",
	asoneg: "As One (Glastrier)",
	asones: "As One (Spectrier)",
	bor: "Beads of Ruin",
	bproof: "Bulletproof",
	dland: "Desolate Land",
	dmaw: "Dragon's Maw",
	emorph: "Electromorphosis",
	fc: "Fur Coat",
	hadron: "Hadron Engine",
	imp: "Imposter",
	intim: "Intimidate",
	mbounce: "Magic Bounce",
	mg: "Magic Guard",
	mguard: "Magic Guard",
	mold: "Mold Breaker",
	ngas: "Neutralizing Gas",
	pixil: "Pixilate",
	pheal: "Poison Heal",
	prank: "Prankster",
	proto: "Protosynthesis",
	psea: "Primordial Sea",
	refrig: "Refrigerate",
	regen: "Regenerator",
	stag: "Shadow Tag",
	sf: "Sheer Force",
	so: "Supreme Overlord",
	sor: "Sword of Ruin",
	tor: "Tablets of Ruin",
	tinted: "Tinted Lens",
	tlens: "Tinted Lens",
	una: "Unaware",
	vor: "Vessel of Ruin",
	vabs: "Volt Absorb",
	wabs: "Water Absorb",
	wbb: "Well-Baked Body",

	// items --- 1st ordered alphabetically by item name, 2nd by alias
	balloon: "Air Balloon",
	assvest: "Assault Vest",
	av: "Assault Vest",
	steelberry: "Babiri Berry",
	bj: "Berry Juice",
	bjuice: "Berry Juice",
	booster: "Booster Energy",
	rockberry: "Charti Berry",
	normalberry: "Chilan Berry",
	band: "Choice Band",
	cb: "Choice Band",
	scarf: "Choice Scarf",
	specs: "Choice Specs",
	fightingberry: "Chople Berry",
	amulet: "Clear Amulet",
	clam: "Clear Amulet",
	flyingberry: "Coba Berry",
	darkberry: "Colbur Berry",
	cloak: "Covert Cloak",
	dragonplate: "Draco Plate",
	darkplate: "Dread Plate",
	groundplate: "Earth Plate",
	evio: "Eviolite",
	ebelt: "Expert Belt",
	fightgem: "Fighting Gem",
	fightingplate: "Fist Plate",
	fireplate: "Flame Plate",
	flightgem: "Flying Gem",
	sash: "Focus Sash",
	dragonberry: "Haban Berry",
	boots: "Heavy-Duty Boots",
	hdb: "Heavy-Duty Boots",
	iceplate: "Icicle Plate",
	bugplate: "Insect Plate",
	steelplate: "Iron Plate",
	ghostberry: "Kasib Berry",
	poisonberry: "Kebia Berry",
	lefties: "Leftovers",
	lo: "Life Orb",
	lorb: "Life Orb",
	dice: "Loaded Dice",
	grassplate: "Meadow Plate",
	psychicplate: "Mind Plate",
	nmi: "Never-Melt Ice",
	fireberry: "Occa Berry",
	waterberry: "Passho Berry",
	psychicberry: "Payapa Berry",
	fairyplate: "Pixie Plate",
	grassberry: "Rindo Berry",
	fairyberry: "Roseli Berry",
	helmet: "Rocky Helmet",
	goggles: "Safety Goggles",
	groundberry: "Shuca Berry",
	flyingplate: "Sky Plate",
	waterplate: "Splash Plate",
	ghostplate: "Spooky Plate",
	rockplate: "Stone Plate",
	bugberry: "Tanga Berry",
	poisonplate: "Toxic Plate",
	tr00swordsdance: "TR00",
	tr01bodyslam: "TR01",
	tr02flamethrower: "TR02",
	tr03hydropump: "TR03",
	tr04surf: "TR04",
	tr05icebeam: "TR05",
	tr06blizzard: "TR06",
	tr07lowkick: "TR07",
	tr08thunderbolt: "TR08",
	tr09thunder: "TR09",
	tr10earthquake: "TR10",
	tr11psychic: "TR11",
	tr12agility: "TR12",
	tr13focusenergy: "TR13",
	tr14metronome: "TR14",
	tr15fireblast: "TR15",
	tr16waterfall: "TR16",
	tr17amnesia: "TR17",
	tr18leechlife: "TR18",
	tr19triattack: "TR19",
	tr20substitute: "TR20",
	tr21reversal: "TR21",
	tr22sludgebomb: "TR22",
	tr23spikes: "TR23",
	tr24outrage: "TR24",
	tr25psyshock: "TR25",
	tr26endure: "TR26",
	tr27sleeptalk: "TR27",
	tr28megahorn: "TR28",
	tr29batonpass: "TR29",
	tr30encore: "TR30",
	tr31irontail: "TR31",
	tr32crunch: "TR32",
	tr33shadowball: "TR33",
	tr34futuresight: "TR34",
	tr35uproar: "TR35",
	tr36heatwave: "TR36",
	tr37taunt: "TR37",
	tr38trick: "TR38",
	tr39superpower: "TR39",
	tr40skillswap: "TR40",
	tr41blazekick: "TR41",
	tr42hypervoice: "TR42",
	tr43overheat: "TR43",
	tr44cosmicpower: "TR44",
	tr45muddywater: "TR45",
	tr46irondefense: "TR46",
	tr47dragonclaw: "TR47",
	tr48bulkup: "TR48",
	tr49calmmind: "TR49",
	tr50leafblade: "TR50",
	tr51dragondance: "TR51",
	tr52gyroball: "TR52",
	tr53closecombat: "TR53",
	tr54toxicspikes: "TR54",
	tr55flareblitz: "TR55",
	tr56aurasphere: "TR56",
	tr57poisonjab: "TR57",
	tr58darkpulse: "TR58",
	tr59seedbomb: "TR59",
	tr60xscissor: "TR60",
	tr61bugbuzz: "TR61",
	tr62dragonpulse: "TR62",
	tr63powergem: "TR63",
	tr64focusblast: "TR64",
	tr65energyball: "TR65",
	tr66bravebird: "TR66",
	tr67earthpower: "TR67",
	tr68nastyplot: "TR68",
	tr69zenheadbutt: "TR69",
	tr70flashcannon: "TR70",
	tr71leafstorm: "TR71",
	tr72powerwhip: "TR72",
	tr73gunkshot: "TR73",
	tr74ironhead: "TR74",
	tr75stoneedge: "TR75",
	tr76stealthrock: "TR76",
	tr77grassknot: "TR77",
	tr78sludgewave: "TR78",
	tr79heavyslam: "TR79",
	tr80electroball: "TR80",
	tr81foulplay: "TR81",
	tr82storedpower: "TR82",
	tr83allyswitch: "TR83",
	tr84scald: "TR84",
	tr85workup: "TR85",
	tr86wildcharge: "TR86",
	tr87drillrun: "TR87",
	tr88heatcrash: "TR88",
	tr89hurricane: "TR89",
	tr90playrough: "TR90",
	tr91venomdrench: "TR91",
	tr92dazzlinggleam: "TR92",
	tr93darkestlariat: "TR93",
	tr94highhorsepower: "TR94",
	tr95throatchop: "TR95",
	tr96pollenpuff: "TR96",
	tr97psychicfangs: "TR97",
	tr98liquidation: "TR98",
	tr99bodypress: "TR99",
	umbrella: "Utility Umbrella",
	electricberry: "Wacan Berry",
	wp: "Weakness Policy",
	electricplate: "Zap Plate",

	// pokemon --- ordered alphabetically by alias
	aboma: "Abomasnow",
	ace: "Cinderace",
	aegi: "Aegislash",
	aegiblade: "Aegislash-Blade",
	aegis: "Aegislash",
	aero: "Aerodactyl",
	alo: "Alomomola",
	amoon: "Amoonguss",
	amoong: "Amoonguss",
	amph: "Ampharos",
	araq: "Araquanid",
	arc: "Arceus",
	arceusnormal: "Arceus",
	arch: "Archaludon",
	ashgren: "Greninja-Ash",
	azu: "Azumarill",
	bax: "Baxcalibur",
	bdrill: "Beedrill",
	bee: "Beedrill",
	belli: "Bellibolt",
	bigsharp: "Kingambit",
	billy: "Squawkabilly",
	birdjesus: "Pidgeot",
	bish: "Bisharp",
	blace: "Blacephalon",
	bliss: "Blissey",
	bomb: "Bombirdier",
	bramble: "Brambleghast",
	bray: "Mudbray",
	bro: "Slowbro",
	bull: "Tauros",
	bulu: "Tapu Bulu",
	camel: "Camerupt",
	carv: "Carvanha",
	cathy: "Trevenant",
	ceru: "Ceruledge",
	chandy: "Chandelure",
	chans: "Chansey",
	ches: "Chesnaught",
	chomp: "Garchomp",
	chou: "Chinchou",
	cind: "Cinderace",
	clanger: "Kommo-o",
	clef: "Clefable",
	clod: "Clodsire",
	cloy: "Cloyster",
	coba: "Cobalion",
	cofag: "Cofagrigus",
	conk: "Conkeldurr",
	copper: "Copperajah",
	corv: "Corviknight",
	cress: "Cresselia",
	croak: "Toxicroak",
	cruel: "Tentacruel",
	cube: "Kyurem-Black",
	cune: "Suicune",
	cuno: "Articuno",
	darm: "Darmanitan",
	decid: "Decidueye",
	dengo: "Gholdengo",
	dirge: "Skeledirge",
	dnite: "Dragonite",
	dogars: "Koffing",
	dogi: "Okidogi",
	doom: "Houndoom",
	dozo: "Dondozo",
	drill: "Excadrill",
	driller: "Excadrill",
	dudun: "Dudunsparce",
	dug: "Dugtrio",
	duggy: "Dugtrio",
	dural: "Duraludon",
	ekiller: "Arceus",
	empo: "Empoleon",
	enam: "Enamorus",
	esca: "Escavalier",
	feral: "Feraligatr",
	ferro: "Ferrothorn",
	fez: "Fezandipiti",
	fini: "Tapu Fini",
	floon: "Drifloon",
	florg: "Florges",
	foo: "Mienfoo",
	foon: "Foongus",
	forry: "Forretress",
	frill: "Frillish",
	fug: "Rayquaza",
	galv: "Galvantula",
	gambit: "Kingambit",
	gar: "Gengar",
	garde: "Gardevoir",
	garg: "Garganacl",
	gastro: "Gastrodon",
	gatr: "Feraligatr",
	gene: "Genesect",
	ghold: "Gholdengo",
	gira: "Giratina",
	glimm: "Glimmora",
	glisc: "Gliscor",
	gren: "Greninja",
	grimm: "Grimmsnarl",
	gross: "Metagross",
	gyara: "Gyarados",
	hatt: "Hatterene",
	hera: "Heracross",
	hippo: "Hippowdon",
	honch: "Honchkrow",
	honse: "Spectrier",
	horo: "Zoroark-Hisui",
	horoark: "Zoroark-Hisui",
	hydra: "Hydrapple",
	hydrei: "Hydreigon",
	incin: "Incineroar",
	intel: "Inteleon",
	jask: "Ninjask",
	kanga: "Kangaskhan",
	karp: "Magikarp",
	kart: "Kartana",
	keld: "Keldeo",
	keys: "Klefki",
	kilo: "Kilowattrel",
	kix: "Lokix",
	klef: "Klefki",
	koff: "Koffing",
	koko: "Tapu Koko",
	kommo: "Kommo-o",
	kou: "Raikou",
	krook: "Krookodile",
	kyu: "Kyurem",
	kyub: "Kyurem-Black",
	kyuw: "Kyurem-White",
	legion: "Basculegion",
	legionf: "Basculegion-F",
	lego: "Nihilego",
	lele: "Tapu Lele",
	linda: "Fletchinder",
	luc: "Lucario",
	luke: "Lucario",
	lurk: "Golurk",
	lycan: "Lycanroc",
	m2: "Mewtwo",
	mage: "Magearna",
	mamo: "Mamoswine",
	mandi: "Mandibuzz",
	maus: "Maushold",
	maw: "Mawile",
	mence: "Salamence",
	meow: "Meowscarada",
	milo: "Milotic",
	mimi: "Mimikyu",
	mmq: "Mimikyu",
	mola: "Alomomola",
	molt: "Moltres",
	morfentshusbando: "Gengar",
	munki: "Munkidori",
	naga: "Naganadel",
	nape: "Infernape",
	ndd: "Indeedee",
	nebby: "Cosmog",
	necro: "Necrozma",
	nidok: "Nidoking",
	nidoq: "Nidoqueen",
	nite: "Dragonite",
	obama: "Abomasnow",
	oger: "Ogerpon",
	ogre: "Kyogre",
	p2: "Porygon2",
	pao: "Chien-Pao",
	pato: "Psyduck",
	pawn: "Pawniard",
	pech: "Pecharunt",
	peli: "Pelipper",
	pert: "Swampert",
	pex: "Toxapex",
	phero: "Pheromosa",
	pika: "Pikachu",
	pikablu: "Marill",
	pony: "Ponyta",
	pory2: "Porygon2",
	poryz: "Porygon-Z",
	prim: "Primarina",
	pult: "Dragapult",
	pyuku: "Pyukumuku",
	pz: "Porygon-Z",
	quag: "Quagsire",
	quaq: "Quaquaval",
	queen: "Nidoqueen",
	rachi: "Jirachi",
	rai: "Darkrai",
	raj: "Copperajah",
	rank: "Reuniclus",
	ray: "Rayquaza",
	reuni: "Reuniclus",
	rev: "Revavroom",
	rhyp: "Rhyperior",
	ribo: "Ribombee",
	rilla: "Rillaboom",
	roark: "Zoroark",
	runt: "Pecharunt",
	sab: "Sableye",
	sable: "Sableye",
	scept: "Sceptile",
	sciz: "Scizor",
	scoli: "Scolipede",
	seejong: "Sealeo",
	serp: "Serperior",
	shao: "Mienshao",
	silvallynormal: "Silvally",
	skarm: "Skarmory",
	smogon: "Koffing",
	smogonbird: "Talonflame",
	snips: "Drapion",
	snub: "Snubbull",
	spritz: "Spritzee",
	squawk: "Squawkabilly",
	staka: "Stakataka",
	steela: "Celesteela",
	sui: "Suicune",
	swole: "Buzzwole",
	sylv: "Sylveon",
	talon: "Talonflame",
	tang: "Tangrowth",
	tent: "Tentacruel",
	terra: "Terrakion",
	tflame: "Talonflame",
	timb: "Timburr",
	ting: "Ting-Lu",
	toed: "Politoed",
	tomb: "Spiritomb",
	torb: "Voltorb",
	tran: "Heatran",
	tsar: "Tsareena",
	ttar: "Tyranitar",
	typh: "Typhlosion",
	ursa: "Ursaluna",
	venu: "Venusaur",
	viriz: "Virizion",
	vroom: "Revavroom",
	vull: "Vullaby",
	weav: "Weavile",
	weez: "Weezing",
	whimsi: "Whimsicott",
	worm: "Orthworm",
	xern: "Xerneas",
	xurk: "Xurkitree",
	ygod: "Yveltal",
	zac: "Zacian",
	zaci: "Zacian",
	zam: "Alakazam",
	zama: "Zamazenta",
	zard: "Charizard",
	zone: "Magnezone",
	zong: "Bronzong",
	zor: "Scizor",
	zoro: "Zoroark",
	zyg: "Zygarde",

	// ultra beast codenames --- ordered by dex number
	ub01: "Nihilego",
	ub01symbiont: "Nihilego",
	ubsymbiont: "Nihilego",
	ub02a: "Buzzwole",
	ub02absorption: "Buzzwole",
	ubabsorption: "Buzzwole",
	ub02b: "Pheromosa",
	ub02beauty: "Pheromosa",
	ubbeauty: "Pheromosa",
	ub03: "Xurkitree",
	ub03lightning: "Xurkitree",
	ublightning: "Xurkitree",
	ub04blade: "Kartana",
	ubblade: "Kartana",
	ub04blaster: "Celesteela",
	ubblaster: "Celesteela",
	ub05: "Guzzlord",
	ub05glutton: "Guzzlord",
	ubglutton: "Guzzlord",
	ubburst: "Blacephalon",
	ubassembly: "Stakataka",
	ubadhesive: "Poipole",
	ubstinger: "Naganadel",
	ubblack: "Necrozma",

	// moves --- ordered alphabetically by alias
	ajet: "Aqua Jet",
	astral: "Astral Barrage",
	bb: "Brave Bird",
	bd: "Belly Drum",
	bde: "Baby-Doll Eyes",
	blades: "Precipice Blades",
	bleakwind: "Bleakwind Storm",
	bpass: "Baton Pass",
	bpress: "Body Press",
	bp: "Baton Pass",
	cane: "Hurricane",
	cc: "Close Combat",
	cm: "Calm Mind",
	dbond: "Destiny Bond",
	dd: "Dragon Dance",
	dgleam: "Dazzling Gleam",
	dib: "Double Iron Bash",
	dkiss: "Draining Kiss",
	dv: "Dark Void",
	dw: "Dual Wingbeat",
	dwb: "Dual Wingbeat",
	edge: "Stone Edge",
	eforce: "Expanding Force",
	eq: "Earthquake",
	espeed: "Extreme Speed",
	eterrain: "Electric Terrain",
	evoboost: "Extreme Evoboost",
	eweb: "Electroweb",
	faintattack: "Feint Attack",
	fimp: "First Impression",
	fog: "Defog",
	glacial: "Glacial Lance",
	glance: "Glacial Lance",
	glide: "Grassy Glide",
	glowpunch: "Power-Up Punch",
	gterrain: "Grassy Terrain",
	gunk: "Gunk Shot",
	hh: "Helping Hand",
	hhp: "High Horsepower",
	hp: "Hidden Power",
	hpbug: "Hidden Power Bug",
	hpdark: "Hidden Power Dark",
	hpdragon: "Hidden Power Dragon",
	hpelectric: "Hidden Power Electric",
	hpfighting: "Hidden Power Fighting",
	hpfire: "Hidden Power Fire",
	hpflying: "Hidden Power Flying",
	hpghost: "Hidden Power Ghost",
	hpgrass: "Hidden Power Grass",
	hpground: "Hidden Power Ground",
	hpice: "Hidden Power Ice",
	hppoison: "Hidden Power Poison",
	hppsychic: "Hidden Power Psychic",
	hprock: "Hidden Power Rock",
	hpsteel: "Hidden Power Steel",
	hpwater: "Hidden Power Water",
	hjk: "High Jump Kick",
	hijumpkick: "High Jump Kick",
	id: "Iron Defense",
	ihead: "Iron Head",
	knock: "Knock Off",
	lr: "Last Respects",
	maligchain: "Malignant Chain",
	mblast: "Moonblast",
	mir: "Make It Rain",
	moongeist: "Moongeist Beam",
	mterrain: "Misty Terrain",
	np: "Nasty Plot",
	pblades: "Precipice Blades",
	pfists: "Plasma Fists",
	pjab: "Poison Jab",
	playaround: "Play Rough",
	polter: "Poltergeist",
	popbomb: "Population Bomb",
	press: "Body Press",
	psong: "Perish Song",
	psynoise: "Psychic Noise",
	pterrain: "Psychic Terrain",
	pup: "Power-Up Punch",
	qd: "Quiver Dance",
	rocks: "Stealth Rock",
	sandsear: "Sandsear Storm",
	sball: "Shadow Ball",
	sbomb: "Sludge Bomb",
	sd: "Swords Dance",
	se: "Stone Edge",
	sideshellarm: "Shell Side Arm",
	spin: "Rapid Spin",
	sr: "Stealth Rock",
	ssa: "Shell Side Arm",
	starstorm: "Tera Starstorm",
	stoss: "Seismic Toss",
	sub: "Substitute",
	sucker: "Sucker Punch",
	sunsteel: "Sunsteel Strike",
	synth: "Synthesis",
	tarrows: "Thousand Arrows",
	taxel: "Triple Axel",
	tblast: "Tera Blast",
	tclap: "Thunderclap",
	tr: "Trick Room",
	troom: "Trick Room",
	tbolt: "Thunderbolt",
	tpunch: "Thunder Punch",
	tspikes: "Toxic Spikes",
	tw: "Tailwind",
	twave: "Thunder Wave",
	twaves: "Thousand Waves",
	vicegrip: "Vise Grip",
	web: "Sticky Web",
	webs: "Sticky Web",
	wildbolt: "Wildbolt Storm",
	wisp: "Will-O-Wisp",
	wow: "Will-O-Wisp",

	// z-moves --- ordered alphabetically by alias
	"10mv": "10,000,000 Volt Thunderbolt",
	"10mvt": "10,000,000 Volt Thunderbolt",
	clangorous: "Clangorous Soulblaze",
	cs: "Clangorous Soulblaze",
	ee: "Extreme Evoboost",
	genesis: "Genesis Supernova",
	goa: "Guardian of Alola",
	gs: "Genesis Supernova",
	guardian: "Guardian of Alola",
	lets: "Let's Snuggle Forever",
	light: "Light That Burns the Sky",
	lsf: "Let's Snuggle Forever",
	ltbts: "Light That Burns the Sky",
	malicious: "Malicious Moonsault",
	menacing: "Menacing Moonraze Maelstrom",
	mmm: "Menacing Moonraze Maelstrom",
	moonsault: "Malicious Moonsault",
	oceanic: "Oceanic Operetta",
	oo: "Oceanic Operetta",
	pp: "Pulverizing Pancake",
	pulverizing: "Pulverizing Pancake",
	sar: "Sinister Arrow Raid",
	sinister: "Sinister Arrow Raid",
	sssss: "Soul-Stealing 7-Star Strike",
	ss7ss: "Soul-Stealing 7-Star Strike",
	soul: "Soul-Stealing 7-Star Strike",
	soulblaze: "Clangorous Soulblaze",
	soulstealingsevenstarstrike: "Soul-Stealing 7-Star Strike",
	splintered: "Splintered Stormshards",
	stoked: "Stoked Sparksurfer",
	stormshards: "Splintered Stormshards",
	zbug: "Savage Spin-Out",
	zclangingscales: "Clangorous Soulblaze",
	zdark: "Black Hole Eclipse",
	zdarkestlariat: "Malicious Moonsault",
	zdawnwingsnecrozma: "Menacing Moonraze Maelstrom",
	zdecidueye: "Sinister Arrow Raid",
	zdragon: "Devastating Drake",
	zduskmanenecrozma: "Searing Sunraze Smash",
	zelectric: "Gigavolt Havoc",
	zeevee: "Extreme Evoboost",
	zevo: "Extreme Evoboost",
	zfairy: "Twinkle Tackle",
	zflying: "Supersonic Skystrike",
	zfighting: "All-Out Pummeling",
	zfire: "Inferno Overdrive",
	zghost: "Never-Ending Nightmare",
	zgigaimpact: "Pulverizing Pancake",
	zgrass: "Bloom Doom",
	zground: "Tectonic Rage",
	zice: "Subzero Slammer",
	zincineroar: "Malicious Moonsault",
	zkommoo: "Clangorous Soulblaze",
	zlastresort: "Extreme Evoboost",
	zlunala: "Menacing Moonraze Maelstrom",
	zlycanroc: "Splintered Stormshards",
	znaturesmadness: "Guardian of Alola",
	zmarshadow: "Soul-Stealing 7-Star Strike",
	zmew: "Genesis Supernova",
	zmimikyu: "Let's Snuggle Forever",
	zmoongeistbeam: "Menacing Moonraze Maelstrom",
	znecrozma: "Light That Burns the Sky",
	znormal: "Breakneck Blitz",
	zrock: "Continental Crush",
	zphotongeyser: "Light That Burns the Sky",
	zpikachu: "Catastropika",
	zpikachucap: "10,000,000 Volt Thunderbolt",
	zplayrough: "Let's Snuggle Forever",
	zpoison: "Acid Downpour",
	zprimarina: "Oceanic Operetta",
	zpsychic: "Shattered Psyche",
	zraichu: "Stoked Sparksurfer",
	zsnorlax: "Pulverizing Pancake",
	zsolgaleo: "Searing Sunraze Smash",
	zsparklingaria: "Oceanic Operetta",
	zspectralthief: "Soul-Stealing 7-Star Strike",
	zspiritshackle: "Sinister Arrow Raid",
	zsunsteelstrike: "Searing Sunraze Smash",
	zsteel: "Corkscrew Crash",
	zstoneedge: "Splintered Stormshards",
	ztapu: "Guardian of Alola",
	zthunderbolt: "10,000,000 Volt Thunderbolt",
	zultranecrozma: "Light That Burns the Sky",
	zvolttackle: "Catastropika",
	zwater: "Hydro Vortex",

	// Max moves --- ordered alphabetically by alias
	maxbug: "Max Flutterby",
	maxdark: "Max Darkness",
	maxdragon: "Max Wyrmwind",
	maxelectric: "Max Lightning",
	maxfairy: "Max Starfall",
	maxfighting: "Max Knuckle",
	maxfire: "Max Flare",
	maxflying: "Max Airstream",
	maxghost: "Max Phantasm",
	maxgrass: "Max Overgrowth",
	maxground: "Max Quake",
	maxice: "Max Hailstorm",
	maxnormal: "Max Strike",
	maxpoison: "Max Ooze",
	maxpsychic: "Max Mindstorm",
	maxrock: "Max Rockfall",
	maxsteel: "Max Steelspike",
	maxwater: "Max Geyser",
	maxstatus: "Max Guard",
	maxprotect: "Max Guard",

	// G-Max Moves --- ordered alphabetically by alias
	befuddle: "G-Max Befuddle",
	cannonade: "G-Max Cannonade",
	centiferno: "G-Max Centiferno",
	chistrike: "G-Max Chi Strike",
	cuddle: "G-Max Cuddle",
	depletion: "G-Max Depletion",
	drumsolo: "G-Max Drum Solo",
	finale: "G-Max Finale",
	fireball: "G-Max Fireball",
	foamburst: "G-Max Foam Burst",
	goldrush: "G-Max Gold Rush",
	gravitas: "G-Max Gravitas",
	hydrosnipe: "G-Max Hydrosnipe",
	malodor: "G-Max Malodor",
	meltdown: "G-Max Meltdown",
	oneblow: "G-Max One Blow",
	rapidflow: "G-Max Rapid Flow",
	replenish: "G-Max Replenish",
	resonance: "G-Max Resonance",
	sandblast: "G-Max Sandblast",
	smite: "G-Max Smite",
	snooze: "G-Max Snooze",
	steelsurge: "G-Max Steelsurge",
	stonesurge: "G-Max Stonesurge",
	stunshock: "G-Max Stun Shock",
	sweetness: "G-Max Sweetness",
	tartness: "G-Max Tartness",
	terror: "G-Max Terror",
	vinelash: "G-Max Vine Lash",
	volcalith: "G-Max Volcalith",
	voltcrash: "G-Max Volt Crash",
	wildfire: "G-Max Wildfire",
	windrage: "G-Max Wind Rage",

	// Japanese names --- ordered by dex number
	fushigidane: "Bulbasaur",
	fushigisou: "Ivysaur",
	fushigibana: "Venusaur",
	hitokage: "Charmander",
	rizaado: "Charmeleon",
	rizaadon: "Charizard",
	zenigame: "Squirtle",
	kameeru: "Wartortle",
	kamekkusu: "Blastoise",
	kyatapii: "Caterpie",
	toranseru: "Metapod",
	batafurii: "Butterfree",
	biidoru: "Weedle",
	kokuun: "Kakuna",
	supiaa: "Beedrill",
	poppo: "Pidgey",
	pijon: "Pidgeotto",
	pijotto: "Pidgeot",
	koratta: "Rattata",
	ratta: "Raticate",
	onisuzume: "Spearow",
	onidoriru: "Fearow",
	aabo: "Ekans",
	aabokku: "Arbok",
	pikachuu: "Pikachu",
	raichuu: "Raichu",
	sando: "Sandshrew",
	sandopan: "Sandslash",
	nidoranmesu: "Nidoran-F",
	nidoriina: "Nidorina",
	nidokuin: "Nidoqueen",
	nidoranosu: "Nidoran-M",
	nidoriino: "Nidorino",
	nidokingu: "Nidoking",
	pippi: "Clefairy",
	pikushii: "Clefable",
	rokon: "Vulpix",
	kyuukon: "Ninetales",
	purin: "Jigglypuff",
	pukurin: "Wigglytuff",
	zubatto: "Zubat",
	gorubatto: "Golbat",
	nazonokusa: "Oddish",
	kusaihana: "Gloom",
	rafureshia: "Vileplume",
	parasu: "Paras",
	parasekuto: "Parasect",
	konpan: "Venonat",
	morufon: "Venomoth",
	diguda: "Diglett",
	dagutorio: "Dugtrio",
	nyaasu: "Meowth",
	perushian: "Persian",
	kodakku: "Psyduck",
	gorudakku: "Golduck",
	mankii: "Mankey",
	okorizaru: "Primeape",
	gaadi: "Growlithe",
	uindi: "Arcanine",
	nyoromo: "Poliwag",
	nyorozo: "Poliwhirl",
	nyorobon: "Poliwrath",
	keeshy: "Abra",
	yungeraa: "Kadabra",
	fuudin: "Alakazam",
	wanrikii: "Machop",
	goorikii: "Machoke",
	kairikii: "Machamp",
	madatsubomi: "Bellsprout",
	utsudon: "Weepinbell",
	utsubotto: "Victreebel",
	menokurage: "Tentacool",
	dokukurage: "Tentacruel",
	ishitsubute: "Geodude",
	goroon: "Graveler",
	goroonya: "Golem",
	poniita: "Ponyta",
	gyaroppu: "Rapidash",
	yadon: "Slowpoke",
	yadoran: "Slowbro",
	koiru: "Magnemite",
	reakoiru: "Magneton",
	kamonegi: "Farfetch’d",
	doodoo: "Doduo",
	doodorio: "Dodrio",
	pauwau: "Seel",
	jugon: "Dewgong",
	betobetaa: "Grimer",
	betobeton: "Muk",
	sherudaa: "Shellder",
	parushen: "Cloyster",
	goosu: "Gastly",
	goosuto: "Haunter",
	gengaa: "Gengar",
	iwaaku: "Onix",
	suriipu: "Drowzee",
	suriipaa: "Hypno",
	kurabu: "Krabby",
	kinguraa: "Kingler",
	biriridama: "Voltorb",
	marumain: "Electrode",
	tamatama: "Exeggcute",
	nasshii: "Exeggutor",
	karakara: "Cubone",
	garagara: "Marowak",
	sawamuraa: "Hitmonlee",
	ebiwaraa: "Hitmonchan",
	beroringa: "Lickitung",
	dogaasu: "Koffing",
	matadogasu: "Weezing",
	saihoon: "Rhyhorn",
	saidon: "Rhydon",
	rakkii: "Chansey",
	monjara: "Tangela",
	garuura: "Kangaskhan",
	tattsuu: "Horsea",
	shiidora: "Seadra",
	tosakinto: "Goldeen",
	azumaou: "Seaking",
	hitodeman: "Staryu",
	sutaamii: "Starmie",
	bariyaado: "Mr. Mime",
	sutoraiku: "Scyther",
	ruujura: "Jynx",
	erebuu: "Electabuzz",
	buubaa: "Magmar",
	kairosu: "Pinsir",
	kentarosu: "Tauros",
	koikingu: "Magikarp",
	gyaradosu: "Gyarados",
	rapurasu: "Lapras",
	metamon: "Ditto",
	iibui: "Eevee",
	shawaazu: "Vaporeon",
	sandaasu: "Jolteon",
	buusutaa: "Flareon",
	porigon: "Porygon",
	omunaito: "Omanyte",
	omusutaa: "Omastar",
	kabutopusu: "Kabutops",
	putera: "Aerodactyl",
	kabigon: "Snorlax",
	furiizaa: "Articuno",
	sandaa: "Zapdos",
	faiyaa: "Moltres",
	miniryuu: "Dratini",
	hakuryuu: "Dragonair",
	kairyuu: "Dragonite",
	myuutsuu: "Mewtwo",
	myuu: "Mew",
	chikoriita: "Chikorita",
	beiriifu: "Bayleef",
	meganiumu: "Meganium",
	hinoarashi: "Cyndaquil",
	magumarashi: "Quilava",
	bakufuun: "Typhlosion",
	waninoko: "Totodile",
	arigeitsu: "Croconaw",
	oodairu: "Feraligatr",
	otachi: "Sentret",
	ootachi: "Furret",
	hoohoo: "Hoothoot",
	yorunozuku: "Noctowl",
	rediba: "Ledyba",
	redian: "Ledian",
	itomaru: "Spinarak",
	ariadosu: "Ariados",
	kurobatto: "Crobat",
	chonchii: "Chinchou",
	rantaan: "Lanturn",
	pichuu: "Pichu",
	py: "Cleffa",
	pupurin: "Igglybuff",
	togepii: "Togepi",
	togechikku: "Togetic",
	neitei: "Natu",
	neiteio: "Xatu",
	meriipu: "Mareep",
	mokoko: "Flaaffy",
	denryuu: "Ampharos",
	kireihana: "Bellossom",
	mariru: "Marill",
	mariruri: "Azumarill",
	usokkii: "Sudowoodo",
	nyorotono: "Politoed",
	hanekko: "Hoppip",
	popokko: "Skiploom",
	watakko: "Jumpluff",
	eipamu: "Aipom",
	himanattsu: "Sunkern",
	kimawari: "Sunflora",
	yanyanma: "Yanma",
	upaa: "Wooper",
	nuoo: "Quagsire",
	eefi: "Espeon",
	burakkii: "Umbreon",
	yamikarasu: "Murkrow",
	yadokingu: "Slowking",
	muuma: "Misdreavus",
	annoon: "Unown",
	soonansu: "Wobbuffet",
	kirinriki: "Girafarig",
	kunugidama: "Pineco",
	foretosu: "Forretress",
	nokotchi: "Dunsparce",
	guraigaa: "Gligar",
	haganeeru: "Steelix",
	buruu: "Snubbull",
	guranburu: "Granbull",
	hariisen: "Qwilfish",
	hassamu: "Scizor",
	tsubotsubo: "Shuckle",
	herakurosu: "Heracross",
	nyuura: "Sneasel",
	himeguma: "Teddiursa",
	ringuma: "Ursaring",
	magumaggu: "Slugma",
	magukarugo: "Magcargo",
	urimuu: "Swinub",
	inomuu: "Piloswine",
	saniigo: "Corsola",
	teppouo: "Remoraid",
	okutan: "Octillery",
	deribaado: "Delibird",
	mantain: "Mantine",
	eaamudo: "Skarmory",
	derubiru: "Houndour",
	herugaa: "Houndoom",
	kingudora: "Kingdra",
	gomazou: "Phanpy",
	donfan: "Donphan",
	porigon2: "Porygon2",
	odoshishi: "Stantler",
	dooburu: "Smeargle",
	barukii: "Tyrogue",
	kapoeraa: "Hitmontop",
	muchuuru: "Smoochum",
	erekiddo: "Elekid",
	buby: "Magby",
	mirutanku: "Miltank",
	hapinasu: "Blissey",
	suikun: "Suicune",
	yoogirasu: "Larvitar",
	sanagirasu: "Pupitar",
	bangirasu: "Tyranitar",
	rugia: "Lugia",
	houou: "Ho-Oh",
	sereby: "Celebi",
	kimori: "Treecko",
	juputoru: "Grovyle",
	jukain: "Sceptile",
	achamo: "Torchic",
	wakashamo: "Combusken",
	bashaamo: "Blaziken",
	mizugorou: "Mudkip",
	numakuroo: "Marshtomp",
	raguraaji: "Swampert",
	pochiena: "Poochyena",
	guraena: "Mightyena",
	jiguzaguma: "Zigzagoon",
	massuguma: "Linoone",
	kemusso: "Wurmple",
	karasarisu: "Silcoon",
	agehanto: "Beautifly",
	mayurudo: "Cascoon",
	dokukeiru: "Dustox",
	hasuboo: "Lotad",
	hasuburero: "Lombre",
	runpappa: "Ludicolo",
	taneboo: "Seedot",
	konohana: "Nuzleaf",
	daatengu: "Shiftry",
	subame: "Taillow",
	oosubame: "Swellow",
	kyamome: "Wingull",
	perippaa: "Pelipper",
	rarutosu: "Ralts",
	kiruria: "Kirlia",
	saanaito: "Gardevoir",
	ametama: "Surskit",
	amemoosu: "Masquerain",
	kinokoko: "Shroomish",
	kinogassa: "Breloom",
	namakero: "Slakoth",
	yarukimono: "Vigoroth",
	kekkingu: "Slaking",
	tsuchinin: "Nincada",
	tekkanin: "Ninjask",
	nukenin: "Shedinja",
	gonyonyo: "Whismur",
	dogoomu: "Loudred",
	bakuongu: "Exploud",
	makunoshita: "Makuhita",
	hariteyama: "Hariyama",
	ruriri: "Azurill",
	nozupasu: "Nosepass",
	eneko: "Skitty",
	enekororo: "Delcatty",
	yamirami: "Sableye",
	kuchiito: "Mawile",
	kokodora: "Aron",
	kodora: "Lairon",
	bosugodora: "Aggron",
	asanan: "Meditite",
	chaaremu: "Medicham",
	rakurai: "Electrike",
	raiboruto: "Manectric",
	purasuru: "Plusle",
	mainan: "Minun",
	barubiito: "Volbeat",
	irumiize: "Illumise",
	rozeria: "Roselia",
	gokurin: "Gulpin",
	marunoomu: "Swalot",
	kibania: "Carvanha",
	samehadaa: "Sharpedo",
	hoeruko: "Wailmer",
	hoeruoo: "Wailord",
	donmeru: "Numel",
	bakuuda: "Camerupt",
	kootasu: "Torkoal",
	banebuu: "Spoink",
	buupiggu: "Grumpig",
	patchiiru: "Spinda",
	nakkuraa: "Trapinch",
	biburaaba: "Vibrava",
	furaigon: "Flygon",
	sabonea: "Cacnea",
	nokutasu: "Cacturne",
	chirutto: "Swablu",
	chirutarisu: "Altaria",
	zanguusu: "Zangoose",
	habuneeku: "Seviper",
	runatoon: "Lunatone",
	sorurokku: "Solrock",
	dojotchi: "Barboach",
	namazun: "Whiscash",
	heigani: "Corphish",
	shizarigaa: "Crawdaunt",
	yajiron: "Baltoy",
	nendooru: "Claydol",
	ririira: "Lileep",
	yureidoru: "Cradily",
	anopusu: "Anorith",
	aamarudo: "Armaldo",
	hinbasu: "Feebas",
	mirokarosu: "Milotic",
	powarun: "Castform",
	kakureon: "Kecleon",
	kagebouzu: "Shuppet",
	jupetta: "Banette",
	yomawaru: "Duskull",
	samayooru: "Dusclops",
	toropiusu: "Tropius",
	chiriin: "Chimecho",
	abusoru: "Absol",
	soonano: "Wynaut",
	yukiwarashi: "Snorunt",
	onigoori: "Glalie",
	tamazarashi: "Spheal",
	todoguraa: "Sealeo",
	todozeruga: "Walrein",
	paaruru: "Clamperl",
	hanteeru: "Huntail",
	sakurabisu: "Gorebyss",
	jiiransu: "Relicanth",
	rabukasu: "Luvdisc",
	tatsubei: "Bagon",
	komoruu: "Shelgon",
	boomanda: "Salamence",
	danbaru: "Beldum",
	metangu: "Metang",
	metagurosu: "Metagross",
	rejirokku: "Regirock",
	rejiaisu: "Regice",
	rejisuchiru: "Registeel",
	rateiasu: "Latias",
	rateiosu: "Latios",
	kaiooga: "Kyogre",
	guraadon: "Groudon",
	rekkuuza: "Rayquaza",
	jiraachi: "Jirachi",
	deokishisu: "Deoxys",
	naetoru: "Turtwig",
	hayashigame: "Grotle",
	dodaitosu: "Torterra",
	hikozaru: "Chimchar",
	moukazaru: "Monferno",
	goukazaru: "Infernape",
	potchama: "Piplup",
	pottaishi: "Prinplup",
	enperuto: "Empoleon",
	mukkuru: "Starly",
	mukubaado: "Staravia",
	mukuhooku: "Staraptor",
	bippa: "Bidoof",
	biidaru: "Bibarel",
	korobooshi: "Kricketot",
	korotokku: "Kricketune",
	korinku: "Shinx",
	rukushio: "Luxio",
	rentoraa: "Luxray",
	subomii: "Budew",
	rozureido: "Roserade",
	zugaidosu: "Cranidos",
	ramuparudo: "Rampardos",
	tatetopusu: "Shieldon",
	toridepusu: "Bastiodon",
	minomutchi: "Burmy",
	minomadamu: "Wormadam",
	gaameiru: "Mothim",
	mitsuhanii: "Combee",
	biikuin: "Vespiquen",
	buizeru: "Buizel",
	furoozeru: "Floatzel",
	cherinbo: "Cherubi",
	cherimu: "Cherrim",
	karanakushi: "Shellos",
	toritodon: "Gastrodon",
	eteboosu: "Ambipom",
	fuwante: "Drifloon",
	fuwaraido: "Drifblim",
	mimiroru: "Buneary",
	mimiroppu: "Lopunny",
	muumaaji: "Mismagius",
	donkarasu: "Honchkrow",
	nyarumaa: "Glameow",
	bunyatto: "Purugly",
	riishan: "Chingling",
	sukanpuu: "Stunky",
	sukatanku: "Skuntank",
	doomiraa: "Bronzor",
	dootakun: "Bronzong",
	usohachi: "Bonsly",
	manene: "Mime Jr.",
	pinpuku: "Happiny",
	perappu: "Chatot",
	mikaruge: "Spiritomb",
	fukamaru: "Gible",
	gabaito: "Gabite",
	gaburiasu: "Garchomp",
	gonbe: "Munchlax",
	rioru: "Riolu",
	rukario: "Lucario",
	hipopotasu: "Hippopotas",
	kabarudon: "Hippowdon",
	sukorupi: "Skorupi",
	dorapion: "Drapion",
	guregguru: "Croagunk",
	dokuroggu: "Toxicroak",
	masukippa: "Carnivine",
	keikouo: "Finneon",
	neoranto: "Lumineon",
	tamanta: "Mantyke",
	yukikaburi: "Snover",
	yukinooo: "Abomasnow",
	manyuura: "Weavile",
	jibakoiru: "Magnezone",
	beroberuto: "Lickilicky",
	dosaidon: "Rhyperior",
	mojanbo: "Tangrowth",
	erekiburu: "Electivire",
	buubaan: "Magmortar",
	togekissu: "Togekiss",
	megayanma: "Yanmega",
	riifia: "Leafeon",
	gureishia: "Glaceon",
	guraion: "Gliscor",
	manmuu: "Mamoswine",
	porigonz: "Porygon-Z",
	erureido: "Gallade",
	dainoozu: "Probopass",
	yonowaaru: "Dusknoir",
	yukimenoko: "Froslass",
	rotomu: "Rotom",
	yukushii: "Uxie",
	emuritto: "Mesprit",
	agunomu: "Azelf",
	diaruga: "Dialga",
	parukia: "Palkia",
	hiidoran: "Heatran",
	rejigigasu: "Regigigas",
	girateina: "Giratina",
	kureseria: "Cresselia",
	fione: "Phione",
	manafi: "Manaphy",
	daakurai: "Darkrai",
	sheimi: "Shaymin",
	aruseusu: "Arceus",
	bikuteini: "Victini",
	tsutaaja: "Snivy",
	janobii: "Servine",
	jarooda: "Serperior",
	pokabu: "Tepig",
	chaobuu: "Pignite",
	enbuoo: "Emboar",
	mijumaru: "Oshawott",
	futachimaru: "Dewott",
	daikenki: "Samurott",
	minezumi: "Patrat",
	miruhoggu: "Watchog",
	yooterii: "Lillipup",
	haaderia: "Herdier",
	muurando: "Stoutland",
	choroneko: "Purrloin",
	reparudasu: "Liepard",
	yanappu: "Pansage",
	yanakkii: "Simisage",
	baoppu: "Pansear",
	baokkii: "Simisear",
	hiyappu: "Panpour",
	hiyakkii: "Simipour",
	mushaana: "Musharna",
	mamepato: "Pidove",
	hatooboo: "Tranquill",
	kenhorou: "Unfezant",
	shimama: "Blitzle",
	zeburaika: "Zebstrika",
	dangoro: "Roggenrola",
	gantoru: "Boldore",
	gigaiasu: "Gigalith",
	koromori: "Woobat",
	kokoromori: "Swoobat",
	moguryuu: "Drilbur",
	doryuuzu: "Excadrill",
	tabunne: "Audino",
	dokkoraa: "Timburr",
	dotekkotsu: "Gurdurr",
	roobushin: "Conkeldurr",
	otamaro: "Tympole",
	gamagaru: "Palpitoad",
	gamageroge: "Seismitoad",
	nageki: "Throh",
	dageki: "Sawk",
	kurumiru: "Sewaddle",
	kurumayu: "Swadloon",
	hahakomori: "Leavanny",
	fushide: "Venipede",
	hoiiga: "Whirlipede",
	pendoraa: "Scolipede",
	monmen: "Cottonee",
	erufuun: "Whimsicott",
	churine: "Petilil",
	doredia: "Lilligant",
	basurao: "Basculin",
	meguroko: "Sandile",
	warubiru: "Krokorok",
	warubiaru: "Krookodile",
	darumakka: "Darumaka",
	hihidaruma: "Darmanitan",
	marakatchi: "Maractus",
	ishizumai: "Dwebble",
	iwaparesu: "Crustle",
	zuruggu: "Scraggy",
	zuruzukin: "Scrafty",
	shinboraa: "Sigilyph",
	desumasu: "Yamask",
	desukaan: "Cofagrigus",
	purotooga: "Tirtouga",
	abagoora: "Carracosta",
	aaken: "Archen",
	aakeosu: "Archeops",
	yabukuron: "Trubbish",
	dasutodasu: "Garbodor",
	zoroa: "Zorua",
	zoroaaku: "Zoroark",
	chiraamy: "Minccino",
	chirachiino: "Cinccino",
	gochimu: "Gothita",
	gochimiru: "Gothorita",
	gochiruzeru: "Gothitelle",
	yuniran: "Solosis",
	daburan: "Duosion",
	rankurusu: "Reuniclus",
	koaruhii: "Ducklett",
	suwanna: "Swanna",
	baniputchi: "Vanillite",
	baniritchi: "Vanillish",
	baibanira: "Vanilluxe",
	shikijika: "Deerling",
	mebukijika: "Sawsbuck",
	emonga: "Emolga",
	kaburumo: "Karrablast",
	shubarugo: "Escavalier",
	tamagetake: "Foongus",
	morobareru: "Amoonguss",
	pururiru: "Frillish",
	burungeru: "Jellicent",
	mamanbou: "Alomomola",
	bachuru: "Joltik",
	denchura: "Galvantula",
	tesshiido: "Ferroseed",
	nattorei: "Ferrothorn",
	giaru: "Klink",
	gigiaru: "Klang",
	gigigiaru: "Klinklang",
	shibishirasu: "Tynamo",
	shibibiiru: "Eelektrik",
	shibirudon: "Eelektross",
	riguree: "Elgyem",
	oobemu: "Beheeyem",
	hitomoshi: "Litwick",
	ranpuraa: "Lampent",
	shandera: "Chandelure",
	kibago: "Axew",
	onondo: "Fraxure",
	ononokusu: "Haxorus",
	kumashun: "Cubchoo",
	tsunbeaa: "Beartic",
	furiijio: "Cryogonal",
	chobomaki: "Shelmet",
	agirudaa: "Accelgor",
	maggyo: "Stunfisk",
	kojofuu: "Mienfoo",
	kojondo: "Mienshao",
	kurimugan: "Druddigon",
	gobitto: "Golett",
	goruugu: "Golurk",
	komatana: "Pawniard",
	kirikizan: "Bisharp",
	baffuron: "Bouffalant",
	washibon: "Rufflet",
	uooguru: "Braviary",
	baruchai: "Vullaby",
	barujiina: "Mandibuzz",
	kuitaran: "Heatmor",
	aianto: "Durant",
	monozu: "Deino",
	jiheddo: "Zweilous",
	sazandora: "Hydreigon",
	meraruba: "Larvesta",
	urugamosu: "Volcarona",
	kobaruon: "Cobalion",
	terakion: "Terrakion",
	birijion: "Virizion",
	torunerosu: "Tornadus",
	borutorosu: "Thundurus",
	reshiramu: "Reshiram",
	zekuromu: "Zekrom",
	randorosu: "Landorus",
	kyuremu: "Kyurem",
	kerudio: "Keldeo",
	meroetta: "Meloetta",
	genosekuto: "Genesect",
	harimaron: "Chespin",
	hariboogu: "Quilladin",
	burigaron: "Chesnaught",
	fokko: "Fennekin",
	teerunaa: "Braixen",
	mafokushii: "Delphox",
	keromatsu: "Froakie",
	gekogashira: "Frogadier",
	gekkouga: "Greninja",
	gekkougasatoshi: "Greninja-Ash",
	satoshigekkouga: "Greninja-Ash",
	horubii: "Bunnelby",
	horuudo: "Diggersby",
	yayakoma: "Fletchling",
	hinoyakoma: "Fletchinder",
	faiaroo: "Talonflame",
	kofukimushi: "Scatterbug",
	kofuurai: "Spewpa",
	bibiyon: "Vivillon",
	shishiko: "Litleo",
	kaenjishi: "Pyroar",
	furabebe: "Flabébé",
	furaette: "Floette",
	furaajesu: "Florges",
	meeekuru: "Skiddo",
	googooto: "Gogoat",
	yanchamu: "Pancham",
	goronda: "Pangoro",
	torimian: "Furfrou",
	nyasupaa: "Espurr",
	nyaonikusu: "Meowstic",
	hitotsuki: "Honedge",
	nidangiru: "Doublade",
	girugarudo: "Aegislash",
	shushupu: "Spritzee",
	furefuwan: "Aromatisse",
	peroppafu: "Swirlix",
	peroriimu: "Slurpuff",
	maaiika: "Inkay",
	karamanero: "Malamar",
	kametete: "Binacle",
	gamenodesu: "Barbaracle",
	kuzumoo: "Skrelp",
	doramidoro: "Dragalge",
	udeppou: "Clauncher",
	burosutaa: "Clawitzer",
	erikiteru: "Helioptile",
	erezaado: "Heliolisk",
	chigorasu: "Tyrunt",
	gachigorasu: "Tyrantrum",
	amarusu: "Amaura",
	amaruruga: "Aurorus",
	ninfia: "Sylveon",
	ruchaburu: "Hawlucha",
	mereshii: "Carbink",
	numera: "Goomy",
	numeiru: "Sliggoo",
	numerugon: "Goodra",
	kureffi: "Klefki",
	bokuree: "Phantump",
	oorotto: "Trevenant",
	baketcha: "Pumpkaboo",
	panpujin: "Gourgeist",
	kachikooru: "Bergmite",
	kurebeesu: "Avalugg",
	onbatto: "Noibat",
	onbaan: "Noivern",
	zeruneasu: "Xerneas",
	iberutaru: "Yveltal",
	jigarude: "Zygarde",
	dianshii: "Diancie",
	fuupa: "Hoopa",
	borukenion: "Volcanion",
	mokuroo: "Rowlet",
	fukusuroo: "Dartrix",
	junaipaa: "Decidueye",
	nyabii: "Litten",
	nyahiito: "Torracat",
	gaogaen: "Incineroar",
	ashimari: "Popplio",
	oshamari: "Brionne",
	ashireenu: "Primarina",
	tsutsukera: "Pikipek",
	kerarappa: "Trumbeak",
	dodekabashi: "Toucannon",
	yanguusu: "Yungoos",
	dekaguusu: "Gumshoos",
	agojimushi: "Grubbin",
	denjimushi: "Charjabug",
	kuwaganon: "Vikavolt",
	makenkani: "Crabrawler",
	kekenkani: "Crabominable",
	odoridori: "Oricorio",
	aburii: "Cutiefly",
	aburibon: "Ribombee",
	iwanko: "Rockruff",
	rugarugan: "Lycanroc",
	yowashi: "Wishiwashi",
	hidoide: "Mareanie",
	dohidoide: "Toxapex",
	dorobanko: "Mudbray",
	banbadoro: "Mudsdale",
	shizukumo: "Dewpider",
	onishizukumo: "Araquanid",
	karikiri: "Fomantis",
	rarantesu: "Lurantis",
	nemashu: "Morelull",
	masheedo: "Shiinotic",
	yatoumori: "Salandit",
	ennyuuto: "Salazzle",
	nuikoguma: "Stufful",
	kiteruguma: "Bewear",
	amakaji: "Bounsweet",
	amamaiko: "Steenee",
	amaajo: "Tsareena",
	kyuwawaa: "Comfey",
	yareyuutan: "Oranguru",
	nagetsukesaru: "Passimian",
	kosokumushi: "Wimpod",
	gusokumusha: "Golisopod",
	sunabaa: "Sandygast",
	shirodesuna: "Palossand",
	namakobushi: "Pyukumuku",
	taipunuru: "Type: Null",
	shiruvuadi: "Silvally",
	meteno: "Minior",
	nekkoara: "Komala",
	bakugamesu: "Turtonator",
	mimikkyu: "Mimikyu",
	hagigishiri: "Bruxish",
	jijiiron: "Drampa",
	dadarin: "Dhelmise",
	jarako: "Jangmo-o",
	jarango: "Hakamo-o",
	jararanga: "Kommo-o",
	kapukokeko: "Tapu Koko",
	kaputetefu: "Tapu Lele",
	kapubururu: "Tapu Bulu",
	kapurehire: "Tapu Fini",
	kosumoggu: "Cosmog",
	kosumoumu: "Cosmoem",
	sorugareo: "Solgaleo",
	runaaara: "Lunala",
	utsuroido: "Nihilego",
	masshibuun: "Buzzwole",
	fierooche: "Pheromosa",
	denjumoku: "Xurkitree",
	tekkaguya: "Celesteela",
	kamitsurugi: "Kartana",
	akujikingu: "Guzzlord",
	nekurozuma: "Necrozma",
	magiana: "Magearna",
	maashadoo: "Marshadow",
	bebenomu: "Poipole",
	aagoyon: "Naganadel",
	tsundetsunde: "Stakataka",
	zugadoon: "Blacephalon",
	merutan: "Meltan",
	merumetaru: "Melmetal",
	sarunori: "Grookey",
	bachinkii: "Thwackey",
	gorirandaa: "Rillaboom",
	hibanii: "Scorbunny",
	rabifutto: "Raboot",
	eesubaan: "Cinderace",
	messon: "Sobble",
	jimereon: "Drizzile",
	intereon: "Inteleon",
	hoshigarisu: "Skwovet",
	yokubarisu: "Greedent",
	kokogara: "Rookidee",
	aogarasu: "Corvisquire",
	aamaagaa: "Corviknight",
	satchimushi: "Blipbug",
	redoomushi: "Dottler",
	iorubu: "Orbeetle",
	kusune: "Nickit",
	fokusurai: "Thievul",
	himenka: "Gossifleur",
	watashiraga: "Eldegoss",
	uuruu: "Wooloo",
	baiuuruu: "Dubwool",
	kamukame: "Chewtle",
	kajirigame: "Drednaw",
	wanpachi: "Yamper",
	parusuwan: "Boltund",
	tandon: "Rolycoly",
	toroggon: "Carkol",
	sekitanzan: "Coalossal",
	kajitchu: "Applin",
	appuryuu: "Flapple",
	taruppuru: "Appletun",
	sunahebi: "Silicobra",
	sadaija: "Sandaconda",
	utsuu: "Cramorant",
	sashikamasu: "Arrokuda",
	kamasujoo: "Barraskewda",
	erezun: "Toxel",
	sutorindaa: "Toxtricity",
	yakude: "Sizzlipede",
	maruyakude: "Centiskorch",
	tatakko: "Clobbopus",
	otosupasu: "Grapploct",
	yabacha: "Sinistea",
	pottodesu: "Polteageist",
	miburimu: "Hatenna",
	teburimu: "Hattrem",
	burimuon: "Hatterene",
	berobaa: "Impidimp",
	gimoo: "Morgrem",
	ooronge: "Grimmsnarl",
	tachifusaguma: "Obstagoon",
	nyaikingu: "Perrserker",
	sanigoon: "Cursola",
	negiganaito: "Sirfetch’d",
	barikooru: "Mr. Rime",
	desubaan: "Runerigus",
	mahomiru: "Milcery",
	mahoippu: "Alcremie",
	taireetsu: "Falinks",
	bachinuni: "Pincurchin",
	yukihami: "Snom",
	mosunou: "Frosmoth",
	ishihenjin: "Stonjourner",
	koorippo: "Eiscue",
	iessan: "Indeedee",
	morupeko: "Morpeko",
	zoudou: "Cufant",
	daioudou: "Copperajah",
	patchiragon: "Dracozolt",
	patchirudon: "Arctozolt",
	uonoragon: "Dracovish",
	uochirudon: "Arctovish",
	jurarudon: "Duraludon",
	dorameshiya: "Dreepy",
	doronchi: "Drakloak",
	doraparuto: "Dragapult",
	zashian: "Zacian",
	mugendaina: "Eternatus",
	dakuma: "Kubfu",
	uuraosu: "Urshifu",
	zaruudo: "Zarude",
	rejiereki: "Regieleki",
	rejidorago: "Regidrago",
	burizaposu: "Glastrier",
	reisuposu: "Spectrier",
	badorekkusu: "Calyrex",
	ayashishi: "Wyrdeer",
	basagiri: "Kleavor",
	gachiguma: "Ursaluna",
	idaitou: "Basculegion",
	oonyuura: "Sneasler",
	hariiman: "Overqwil",
	rabutorosu: "Enamorus",
	nyaoha: "Sprigatito",
	nyaroote: "Floragato",
	masukaanya: "Meowscarada",
	hogeeta: "Fuecoco",
	achigeeta: "Crocalor",
	raudoboon: "Skeledirge",
	kuwassu: "Quaxly",
	uerukamo: "Quaxwell",
	ueenibaru: "Quaquaval",
	guruton: "Lechonk",
	pafuyuuton: "Oinkologne",
	tamanchura: "Tarountula",
	wanaidaa: "Spidops",
	mamebatta: "Nymble",
	ekusureggu: "Lokix",
	pamo: "Pawmi",
	pamotto: "Pawmo",
	paamotto: "Pawmot",
	wakkanezumi: "Tandemaus",
	ikkanezumi: "Maushold",
	papimotchi: "Fidough",
	bauttsueru: "Dachsbun",
	miniibu: "Smoliv",
	oriinyo: "Dolliv",
	oriiva: "Arboliva",
	ikirinko: "Squawkabilly",
	kojio: "Nacli",
	jiozumu: "Naclstack",
	kyojioon: "Garganacl",
	karubou: "Charcadet",
	gurenaruma: "Armarouge",
	soubureizu: "Ceruledge",
	zupika: "Tadbulb",
	harabarii: "Bellibolt",
	kaiden: "Wattrel",
	taikaiden: "Kilowattrel",
	orachifu: "Maschiff",
	mafiteifu: "Mabosstiff",
	shirushuruu: "Shroodle",
	taginguru: "Grafaiai",
	anokusa: "Bramblin",
	anohoragusa: "Brambleghast",
	nonokurage: "Toedscool",
	rikukurage: "Toedscruel",
	gakegani: "Klawf",
	kapusaiji: "Capsakid",
	sukoviran: "Scovillain",
	shigaroko: "Rellor",
	berakasu: "Rabsca",
	hirahina: "Flittle",
	kuesupatora: "Espathra",
	kanuchan: "Tinkatink",
	nakanuchan: "Tinkatuff",
	dekanuchan: "Tinkaton",
	umidiguda: "Wiglett",
	umitorio: "Wugtrio",
	otoshidori: "Bombirdier",
	namiiruka: "Finizen",
	irukaman: "Palafin",
	buroron: "Varoom",
	burororoomu: "Revavroom",
	mototokage: "Cyclizar",
	mimizuzu: "Orthworm",
	kiraame: "Glimmet",
	kirafuroru: "Glimmora",
	bochi: "Greavard",
	hakadoggu: "Houndstone",
	karamingo: "Flamigo",
	arukujira: "Cetoddle",
	harukujira: "Cetitan",
	migaruusa: "Veluza",
	heirassha: "Dondozo",
	sharitatsu: "Tatsugiri",
	konoyozaru: "Annihilape",
	dooo: "Clodsire",
	rikikirin: "Farigiraf",
	nokokotchi: "Dudunsparce",
	dodogezan: "Kingambit",
	idainakiba: "Great Tusk",
	sakebushippo: "Scream Tail",
	araburutake: "Brute Bonnet",
	habatakukami: "Flutter Mane",
	chiwohauhane: "Slither Wing",
	sunanokegawa: "Sandy Shocks",
	tetsunowadachi: "Iron Treads",
	tetsunotsutsumi: "Iron Bundle",
	tetsunokaina: "Iron Hands",
	tetsunokoube: "Iron Jugulis",
	tetsunodokuga: "Iron Moth",
	tetsunoibara: "Iron Thorns",
	sebie: "Frigibax",
	segooru: "Arctibax",
	segureibu: "Baxcalibur",
	korekuree: "Gimmighoul",
	saafugoo: "Gholdengo",
	chionjien: "Wo-Chien",
	paojian: "Chien-Pao",
	dinruu: "Ting-Lu",
	iiyui: "Chi-Yu",
	todorokutsuki: "Roaring Moon",
	tetsunobujin: "Iron Valiant",
	uneruminamo: "Walking Wake",
	tetsunoisaha: "Iron Leaves",
	kamitchu: "Dipplin",
	chadesu: "Poltchageist",
	yabasocha: "Sinistcha",
	iineinu: "Okidogi",
	mashimashira: "Munkidori",
	kichikigisu: "Fezandipiti",
	oogapon: "Ogerpon",
	burijurasu: "Archaludon",
	kamitsuorochi: "Hydrapple",
	ugatsuhomura: "Gouging Fire",
	takeruraiko: "Raging Bolt",
	tetsunoiwao: "Iron Boulder",
	tetsunokashira: "Iron Crown",
	terapagosu: "Terapagos",
	momowarou: "Pecharunt",

	// CAP
	arg: "Arghonaut",
	astro: "Astrolotl",
	auru: "Aurumoth",
	bao: "Jumbao",
	cari: "Caribolt",
	cawm: "Cawmodore",
	colo: "Colossoil",
	chrom: "Chromera",
	chugg: "Chuggalong",
	clo: "Cyclohm",
	clohm: "Cyclohm",
	cresc: "Cresceidon",
	cruci: "Crucibelle",
	ebook: "Venomicon-Epilogue",
	hemo: "Hemogoblin",
	kerf: "Kerfluffle",
	kit: "Kitsunoh",
	krilo: "Krilowatt",
	libra: "Equilibra",
	mala: "Malaconda",
	navi: "Naviathan",
	nect: "Necturna",
	ohmagod: "Plasmanta",
	plas: "Plasmanta",
	raja: "Saharaja",
	ramnarokdormant: "Ramnarok",
	reve: "Revenankh",
	roak: "Pyroak",
	smoko: "Smokomodo",
	snael: "Snaelstrom",
	soil: "Colossoil",
	strata: "Stratagem",
	tomo: "Tomohawk",
	train: "Chuggalong",
	venomicone: "Venomicon-Epilogue",
	venomiconp: "Venomicon",
	venomiconprologue: "Venomicon",
	volk: "Volkraken",
};

/** This is what lets you type "tb"/"tbolt"/"bolt" to find "thunderbolt" in the
  * teambuilder (and PSdex) search. */
export const CompoundWordNames = [
	// species
	'Aboma-snow',
	'Aegi-slash',
	'Aero-dactyl',
	'Alaka-zam',
	'Alomo-mola',
	'Annihil-ape',
	'Arbo-liva',
	'Arca-nine',
	'Archalu-don',
	'Arcti-bax',
	'Arcto-vish',
	'Arcto-zolt',
	'Arma-rouge',
	'Aroma-tisse',
	'Arti-c-uno',
	'Ava-lugg',
	'Barra-skewda',
	'Bascu-legion',
	'Bee-drill',
	'Belli-bolt',
	'Be-wear',
	'Bi-sharp',
	'Bom-birdier',
	'Bramble-ghast',
	'Bre-loom',
	'Bron-zong',
	'Bulba-saur',
	'Buzz-wole',
	'Cac-nea',
	'Cac-turne',
	'Caly-rex',
	'Capsa-kid',
	'Car-bink',
	'Carni-vine',
	'Carra-costa',
	'Cast-form',
	'Cele-bi',
	'Cele-steela',
	'Centi-skorch',
	'Cerul-edge',
	'Chande-lure',
	'Char-cadet',
	'Chari-zard',
	'Char-mander',
	'Ches-naught',
	'Chin-chou',
	'Cin-ccino',
	'Cinder-ace',
	'Clod-sire',
	'Coppe-rajah',
	'Cor-phish',
	'Corvi-knight',
	'Corvi-squire',
	'Craw-daunt',
	'Cycli-zar',
	'Dachs-bun',
	'Dark-rai',
	'Decidu-eye',
	'Del-phox',
	'Dew-gong',
	'Dew-pider',
	'Don-dozo',
	'Don-phan',
	'Dou-blade',
	'Draco-vish',
	'Draco-zolt',
	'Draga-pult',
	'Drago-nair',
	'Drago-nite',
	'Dra-tini',
	'Dred-naw',
	'Drif-blim',
	'Dri-floon',
	'Dudun-sparce',
	'Dug-trio',
	'Dun-sparce',
	'Dura-ludon',
	'Dus-clops',
	'Dusk-noir',
	'Eelek-tross',
	'Elde-goss',
	'Electa-buzz',
	'Electi-vire',
	'Elec-trode',
	'Esca-valier',
	'Exca-drill',
	'Ex-eggutor',
	'Ex-ploud',
	'Fa-links',
	'Fari-giraf',
	'Ferro-seed',
	'Ferro-thorn',
	'Forre-tress',
	'Frigi-bax',
	'Fros-lass',
	'Fros-moth',
	'Fur-frou',
	'Gar-chomp',
	'Garga-nacl',
	'Ghol-dengo',
	'Gimmi-ghoul',
	'Gira-tina',
	'Gli-scor',
	'Gol-duck',
	'Go-lurk',
	'Gour-geist',
	'Gran-bull',
	'Gre-ninja',
	'Grimm-snarl',
	'Grum-pig',
	'Hari-yama',
	'Haw-lucha',
	'Hea-tran',
	'Hitmon-chan',
	'Hitmon-lee',
	'Hitmon-top',
	'Honch-krow',
	'Houn-doom',
	'Hound-stone',
	'Hydr-apple',
	'Hy-dreigon',
	'Infer-n-ape',
	'Ivy-saur',
	'Ji-rachi',
	'Jum-pluff',
	'Kilo-wattrel',
	'Kin-gambit',
	'Klin-klang',
	'Korai-don',
	'Lea-vanny',
	'Ludi-colo',
	'Lumi-neon',
	'Luv-disc',
	'Mag-cargo',
	'Ma-gearna',
	'Magi-karp',
	'Mag-mortar',
	'Magne-zone',
	'Mamo-swine',
	'Mandi-buzz',
	'Medi-cham',
	'Meta-gross',
	'Mien-foo',
	'Mien-shao',
	'Mirai-don',
	'Mol-tres',
	'Mud-bray',
	'Muds-dale',
	'Munch-lax',
	'Mur-krow',
	'Naga-nadel',
	'Nido-king',
	'Nido-queen',
	'Nido-rina',
	'Nido-rino',
	'Nihi-lego',
	'Nine-tales',
	'Noi-vern',
	'Nose-pass',
	'Obsta-goon',
	'Oger-pon',
	'Oki-dogi',
	'Oma-star',
	'Orth-worm',
	'Over-qwil',
	'Palos-sand',
	'Pan-cham',
	'Pan-goro',
	'Pan-pour',
	'Pan-sage',
	'Pan-sear',
	'Pecha-runt',
	'Perr-serker',
	'Phero-mosa',
	'Pilo-swine',
	'Pinc-urchin',
	'Poli-toed',
	'Poli-wrath',
	'Poltcha-geist',
	'Poltea-geist',
	'Prima-rina',
	'Prime-ape',
	'Psy-duck',
	'Pyuku-muku',
	'Quag-sire',
	'Qua-quaval',
	'Rai-kou',
	'Reg-ice',
	'Regi-drago',
	'Regi-eleki',
	'Regi-gigas',
	'Regi-rock',
	'Regi-steel',
	'Reli-canth',
	'Reva-vroom',
	'Rhy-don',
	'Ribom-bee',
	'Rilla-boom',
	'Rock-ruff',
	'Rose-rade',
	'Sala-mence',
	'Samu-rott',
	'Sanda-conda',
	'Sand-shrew',
	'Sand-slash',
	'Saws-buck',
	'Sci-zor',
	'Scoli-pede',
	'Sco-villain',
	'Sea-king',
	'Seismi-toad',
	'Sil-vally',
	'Simi-pour',
	'Simi-sage',
	'Simi-sear',
	'Sizzli-pede',
	'Skele-dirge',
	'Slow-bro',
	'Slow-king',
	'Snor-lax',
	'Sno-runt',
	'Spiri-tomb',
	'Squawka-billy',
	'Stak-ataka',
	'Star-mie',
	'Ston-journer',
	'Sudo-woodo',
	'Sui-cune',
	'Swam-pert',
	'Tad-bulb',
	'Talon-flame',
	'Tan-growth',
	'Tatsu-giri',
	'Tenta-cool',
	'Tenta-cruel',
	'Tera-pagos',
	'Tinka-tink',
	'Tinka-ton',
	'Tinka-tuff',
	'Toeds-cool',
	'Toeds-cruel',
	'Toge-kiss',
	'Tor-terra',
	'Tou-cannon',
	'Toxa-pex',
	'Toxi-croak',
	'Tox-tricity',
	'Tyrani-tar',
	'Ursa-luna',
	'Ursa-luna Blood-moon',
	'Ur-shifu',
	'Veni-pede',
	'Veno-moth',
	'Venu-saur',
	'Vespi-quen',
	'Vika-volt',
	'Vile-plume',
	'Vol-canion',
	'Vol-carona',
	'Vul-pix',
	'Wea-vile',
	'Whirli-pede',
	'Wug-trio',
	'Wyr-deer',
	'Xurki-tree',
	'Zama-zenta',
	'Zap-dos',

	// moves
	'10,000,000 Volt Thunder-bolt',
	'Accele-rock',
	'Acid Down-pour',
	'Acu-pressure',
	'Aero-blast',
	'Aroma-therapy',
	'Ava-lanche',
	'Boom-burst',
	'Bleak-wind Storm',
	'Break-neck Blitz',
	'Bull-doze',
	'Catastro-pika',
	'Cease-less Edge',
	'Chloro-blast',
	'Clangorous Soul-blaze',
	'Copy-cat',
	'Cork-screw Crash',
	'Crab-hammer',
	'Dis-charge',
	'Dual Wing-beat',
	'Dyna-max Cannon',
	'Earth-quake',
	'Electro-web',
	'Eterna-beam',
	'Extra-sensory',
	'Extreme Evo-boost',
	'Flame-thrower',
	'Geo-mancy',
	'Giga-volt Havoc',
	'Head-butt',
	'Head-long Rush',
	'High Horse-power',
	'Hurri-cane',
	'Hyper-space Fury',
	'Hyper-space Hole',
	'Inferno Over-drive',
	'Kow-tow Cleave',
	'Malicious Moon-sault',
	'Max Air-stream',
	'Max Flutter-by',
	'Max Hail-storm',
	'Max Mind-storm',
	'Max Over-growth',
	'Max Rock-fall',
	'Max Star-fall',
	'Max Steel-spike',
	'Max Wyrm-wind',
	'Mega-horn',
	'Menacing Moon-raze Maelstrom',
	'Moon-blast',
	'Moon-geist Beam',
	'Moon-light',
	'Never-Ending Night-mare',
	'Over-drive',
	'Over-heat',
	'Out-rage',
	'Octa-zooka',
	'Octo-lock',
	'Pay-back',
	'Polter-geist',
	'Preci-pice Blades',
	'Psy-blade',
	'Psy-shock',
	'Psy-shield Bash',
	'Psy-wave',
	'Roto-tiller',
	'Roll-out',
	'Safe-guard',
	'Sand-storm',
	'Sand-sear Storm',
	'Searing Sun-raze Smash',
	'Sky Upper-cut',
	'Smoke-screen',
	'Snow-scape',
	'Splintered Storm-shards',
	'Spring-tide Storm',
	'Stock-pile',
	'Steam-roller',
	'Stoked Spark-surfer',
	'Sub-zero Slammer',
	'Sun-steel Strike',
	'Super-cell Slam',
	'Super-power',
	'Super-sonic',
	'Super-sonic Sky-strike',
	'Synchro-noise',
	'Tail-wind',
	'Tele-kinesis',
	'Tele-port',
	'Tea-time',
	'Tera Star-storm',
	'Thunder-clap',
	'Thunder-bolt',
	'Trail-blaze',
	'Twi-needle',
	'Up-roar',
	'Veno-shock',
	'Water-fall',
	'Whirl-pool',
	'Whirl-wind',
	'Wild-bolt Storm',

	// abilities
	'Bullet-proof',
	'Down-load',
	'Electro-morphosis',
	'Fore-warn',
	'Heat-proof',
	'Multi-scale',
	'Multi-type',
	'Neuro-force',
	'Pick-pocket',
	'Proto-synthesis',
	'Reck-less',
	'Sound-proof',
	'Steel-worker',
	'Super-sweet Syrup',
	'Tera-form Zero',
	'Tera-volt',
	'Turbo-blaze',
	'Un-seen Fist',
];
